import { transfer } from "@/lobby_common/api/payment_gen.js";
import { getGameGroupBySid, getGameLimit } from "@/lobby_common/api/game_gen";
import { getBankruptConfig } from "@/lobby_common/api/guess_gen.js";
import { getUserFirstWithdrawInfo } from "@/lobby_common/api/payment_gen.js";
import { Encrypt, Decrypt } from "@/lobby_common/utils/secret.js";
import { getCoinExchangeRate } from "@/lobby_common/api/basic_gen";
import { getAppPromptInfo } from "@/lobby_common/api/resource_gen";
import {
  getNewUserHelpInfo,
  getActivityRewardGuide,
  previewRechargeReward,
  redEnvelopeTimingGet,
  getRechargeTurntableInfo,
} from "@/lobby_common/api/activity_gen.js";
// 通过TG机器人ID获取TG分享地址
import { getPacketRobotBySid } from "@/lobby_common/api/basic_gen.js";
import {
  getAnyZoneTimeStamp,
  getDateLastTimeStampe,
  getAppTimeStamp,
  getAppDateLastTimeStampe,
} from "./date.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import { copyFun, encodeBase64 } from "@/lobby_common/utils/index.js";
import TelegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { getLocalStorage, setLocalStorage } from "./auth.js";
import {
  afPostEvent,
  locationJump,
} from "@/lobby_common/utils/eventFunction.js";
import { dynamicCreateManifest } from "@/lobby_common/utils/dynamicCreateManifest";
import Store from "@/lobby_common/store/index";
import { setLocale } from "@/lobby_common/locale";
import { updateUserLanguage } from "@/lobby_common/api/user_gen.js";
import { rechargeOrderListByOrderNumbers } from "@/lobby_common/api/payment_gen.js";
import coinImage1 from "@/lobby_common/mixins_components/RankReward/coin_a.png";
import coinImage2 from "@/lobby_common/mixins_components/RankReward/coin_b.png";
import coinImage3 from "@/lobby_common/mixins_components/RankReward/coin_c.png";
import coinImage4 from "@/lobby_common/mixins_components/RankReward/coin_d.png";
import coinBirth from "@/lobby_common/mixins_components/RankReward/coinBirth.png";
import { redRedeemCodeReceive } from "@/lobby_common/api/activity_gen.js";
let vm = null;
export function sendThis(_this) {
  vm = _this;
}
export const SIN_KEY = "D5nLQ%tNCUBJ@6HHXb3R";
export const utils = {
  Transformation: 100, // 金币转化比列
  fomatFloat(src, pos = 2) {
    // 处理小数位数向上向下取整
    // src是要保留小数的值，pos是要保留几位小数；
    if (src) {
      return Math.floor(src * Math.pow(10, pos)) / Math.pow(10, pos);
    } else {
      return 0;
    }
  },
  // var nums=fomatFloat(num,3)
  // 排序 从大到小
  compare(p) {
    // 这是比较函数排序
    return function (m, n) {
      const a = m[p];
      const b = n[p];
      return b - a; // 升序
    };
  },
  numFormat(num) {
    num = num.toString().split("."); // 分隔小数点
    const arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
    let res = [];
    for (let i = 0, len = arr.length; i < len; i++) {
      if (i % 3 === 0 && i !== 0) {
        res.push(","); // 添加分隔符
      }
      res.push(arr[i]);
    }
    res.reverse(); // 再次倒序成为正确的顺序
    if (num[1]) {
      // 如果有小数的话添加小数部分
      res = res.join("").concat("." + num[1]);
    } else {
      res = res.join("");
    }
    return res;
  },
  // 除某个值（默认100）保留整数
  fomatDivide(num, dividend = 100) {
    if (num) return parseInt(num / dividend);
    else return 0;
  },
  // 拼接图片地址
  // returnImgUrl(url) {
  //   if (!url) {
  //     return vm.$store.getters.getPacketDomain?.webHotUpdateUrl;
  //   }
  //   return vm.$store.getters.getPacketDomain?.webHotUpdateUrl + url;
  // },
  returnImgUrl(url) {
    if (typeof url !== "string" || !url.trim()) {
      return vm.$store.getters.getPacketDomain?.webHotUpdateUrl || "";
    }
    // 如果 `url` 以 http 或 https 开头，直接返回
    if (/^https?:\/\//.test(url)) {
      return url;
    }
    const baseUrl = vm.$store.getters.getPacketDomain?.webHotUpdateUrl || "";
    // 确保拼接时不会丢失 `/`
    return baseUrl.replace(/\/$/, "") + "/" + url.replace(/^\//, "");
  },
  lang_data(lang, row, data1) {
    // console.log(lang, row, data1, "lang, row, data1");
    const rowdata = row || {};
    if (rowdata[data1][lang]) {
      return rowdata[data1][lang];
    } else {
      return rowdata[data1]["en"];
    }
  },
  // 头像
  avatarUrl(avatarImg = "") {
    const avatar = avatarImg || vm.$store.getters.user?.avatar || "1";
    let url = "";
    if (Number.isFinite(Number(avatar))) {
      // 自研头像
      url = require(`@/assets/img/head/head_${avatar}.png`);
    } else {
      // tg头像
      url = avatar;
    }
    return url;
  },
  isMp4(url) {
    return /\.mp4$/i.test(url);
  },
};
// 拼接图
export function renderTemplate(template, data) {
  // console.log(template, data);
  const reg = /\{\{(\w+)\}\}/; // 模板字符串正则
  if (reg.test(template)) {
    // 判断模板里是否有模板字符串
    const name = reg.exec(template)[1]; // 查找当前模板里第一个模板字符串的字段
    template = template.replace(reg, data[name]); // 将第一个模板字符串渲染
    return renderTemplate(template, data); // 递归的渲染并返回渲染后的结构
  }
  return template; // 如果模板没有模板字符串直接返回
}

// 获取三方字段
export function getAdsCode() {
  const opt = {};
  const kwai_obj = getLocalStorage("kwai_obj");
  const ttclid = getLocalStorage("ttclid");
  const fbclid = getLocalStorage("fbclid");
  const uniqueId = window.localStorage.getItem("uniqueId");
  const visitor_id = getLocalStorage("visitor_id");
  const afdata = getLocalStorage("appsflyer_id");
  const adjust_adid = getLocalStorage("adjust_adid");
  const promoteSid = localStorage.getItem("promoteSid");
  const installId = localStorage.getItem("install_id");
  let urlParams = null;
  try {
    urlParams = JSON.parse(localStorage.getItem("urlParams") || "");
  } catch (err) {}
  if (kwai_obj?.click_id) {
    opt.adsCode = "ADS_CODE_KWAI";
    opt.adsUserId = kwai_obj?.click_id;
  }
  if (ttclid) {
    opt.adsCode = "ADS_CODE_TIKTOK";
    opt.adsUserId = ttclid;
  }
  if (fbclid) {
    opt.adsCode = "ADS_CODE_FACEBOOK_CONVERSION";
    opt.adsUserId = fbclid;
  }
  if (adjust_adid) {
    opt.adsCode = "ADS_CODE_ADJUST";
    opt.adsUserId = adjust_adid;
  }
  if (visitor_id) {
    opt.adsCode = "ADS_CODE_PROPELLER_ADS";
    opt.adsUserId = visitor_id;
  }
  if (afdata && afdata.appsflyer_id) {
    opt.adsCode = "ADS_CODE_AF";
    opt.adsUserId = `&&&${afdata.appsflyer_id}`;
  }
  if (promoteSid) {
    opt.promoteSid = promoteSid;
  }
  if (uniqueId) {
    opt.uniqueId = uniqueId;
  }
  if (installId) {
    opt.promoteClipboardId = installId;
  }
  if (urlParams) {
    opt.adsCustomParams = urlParams;
  }
  return opt;
}

//  获取channel 逻辑上传
export function getchannel() {
  const params = {};
  params.channel = localStorage.getItem("channelId") || "0";

  return { ...params };
}

// 获取设备信息 设备id，设备名称
export function getDeviceInfo() {
  const params = {};
  const initQuery = getLocalStorage("initQuery") || {};
  params.channel_id = localStorage.getItem("channelId") || "0";
  const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));

  // 浏览器指纹
  let browser = localStorage.getItem("browser");
  browser = browser ? JSON.parse(browser) : "";
  if (browser?.browser && browser?.murmur) {
    params.deviceId = browser.murmur;
    params.deviceName = browser.browser;
  }
  // 马甲包  tg快速登陆
  if (isFromApp || initQuery?.ft === "tg") {
    params.deviceId = initQuery?.device_id || params.deviceId;
    params.deviceName = initQuery?.ft || params.deviceName;
  }
  return { ...params };
}

// 返回数组中的最大值最小值区间
export function minMax(arr, accuracy) {
  const newArr = [...arr];
  if (newArr && newArr.length > 1) {
    const min = Math.min(...newArr);
    const max = Math.max(...newArr);
    return `${divideAccuracy(min, accuracy, "point")} ~ ${divideAccuracy(
      max,
      accuracy,
      "point"
    )}`;
  } else if (newArr && newArr.length === 1) {
    return `${divideAccuracy(newArr[0], accuracy, "point")}`;
  } else {
    return "";
  }
}

// let template = '我是{{name}}，年龄{{age}}，性别{{sex}}';
// let person = {    name: '布兰',    age: 12}
// render(template, person);
/**
 *
 * @param {Object} obj
 * @param {String} type
 * @returns  key=value&key1=value1pe
 */
export const postParamStr = (obj = {}, type = "&") => {
  if (Object.keys(obj).length === 0 || obj.constructor !== Object) return "";
  const w = Object.entries(obj);
  w.forEach((v, i) => {
    w[i] = v.join("=");
  });
  return w.join(type);
};

/**
 *  深度拷贝
 * @param {*} obj
 * @param {*} hash
 * @returns
 */
export function deepClone(obj, hash = new WeakMap()) {
  if (hash.has(obj)) {
    return obj;
  }
  let res = null;
  const reference = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error];
  // eslint-disable-next-line valid-typeof
  const isObj = typeof obj === "Object";
  if (reference.includes(obj?.constructor)) {
    res = new obj.constructor(obj);
  } else if (Array.isArray(obj)) {
    res = [];
    obj.forEach((e, i) => {
      res[i] = deepClone(e);
    });
  } else if (isObj && obj !== null) {
    res = {};
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        res[key] = deepClone(obj[key]);
      }
    }
  } else {
    res = obj;
  }
  hash.set(obj, res);
  return res;
}

export function formatTimedown(time) {
  let countDown = "";
  let h = Math.floor(time / 3600);
  let m = Math.floor((time % 3600) / 60);
  let s = time % 60;
  h = h > 9 ? h : "0" + h;
  m = m > 9 ? m : "0" + m;
  s = s > 9 ? s : "0" + s;
  countDown = h + ":" + m + ":" + s;
  return countDown;
}

/**
 * 时间格式化
 * @param {number} time
 * @param {string} type
 * @returns {string}
 */
export function formatTime(time, type = "-", fmt = false) {
  let date = null;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^\d+$/.test(time)) {
        if (("" + time).length === 10) {
          time = parseInt(time) * 1000;
        }
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const times = new Date(date);
  const y = times.getFullYear();
  const m =
    times.getMonth() + 1 < 10
      ? "0" + (times.getMonth() + 1)
      : times.getMonth() + 1;
  const d = times.getDate() < 10 ? "0" + times.getDate() : times.getDate();
  const h = times.getHours() < 10 ? "0" + times.getHours() : times.getHours();
  const s =
    times.getMinutes() < 10 ? "0" + times.getMinutes() : times.getMinutes();
  const ss =
    times.getSeconds() < 10 ? "0" + times.getSeconds() : times.getSeconds();
  // return y + type + m + type + d + " " + h + " : " + s + " : " + ss;
  if (fmt) {
    return y + type + m + type + d + "  " + h + ":" + s + ":" + ss;
  } else {
    return y + type + m + type + d + "  " + h + ":" + s;
  }
}
/**
 * 时间格式化
 * @param {number} time
 * @param {string} type
 * @returns {string}
 */
// export function formatDate(time, type = "-") {
//   let date = null;
//   if (typeof time === "object") {
//     date = time;
//   } else {
//     if (typeof time === "string") {
//       if (/^\d+$/.test(time)) {
//         if (("" + time).length === 10) {
//           time = parseInt(time) * 1000;
//         }
//         time = parseInt(time);
//       } else {
//         time = time.replace(new RegExp(/-/gm), "/");
//       }
//     }

//     if (typeof time === "number" && time.toString().length === 10) {
//       time = time * 1000;
//     }
//     date = new Date(time);
//   }
//   const times = new Date(date);
//   const y = times.getFullYear();
//   const m =
//     times.getMonth() + 1 < 10
//       ? "0" + (times.getMonth() + 1)
//       : times.getMonth() + 1;
//   const d = times.getDate() < 10 ? "0" + times.getDate() : times.getDate();

//   return y + type + m + type + d;
// }

export function formatTimeToStr(times, pattern) {
  if (!times) return times;
  let d = new Date(times).Format("yyyy-MM-dd hh:mm:ss");
  if (pattern) {
    d = new Date(times).Format(pattern);
  }
  return d.toLocaleString();
}
// 时间戳处理 时区问题 timeStamp 时间 1211221  timeZone ，那个区域 -4(美东) 类似
export function getAnyZoneTime(timeStamp, pattern = "yyyy-MM-dd hh:mm:ss") {
  const timeStampTmp = getAnyZoneTimeStamp(timeStamp);
  return formatTimeToStr(new Date(timeStampTmp), pattern);
}

//  时区处理
export function getAnyZone(timeStamp) {
  const timeStampTmp = getAnyZoneTimeStamp(timeStamp);
  return new Date(timeStampTmp);
}
// export function getUTCTime() {
//   const d1 = new Date();
//   const d2 = new Date(
//     d1.getUTCFullYear(),
//     d1.getUTCMonth(),
//     d1.getUTCDate(),
//     d1.getUTCHours() - 4,
//     d1.getUTCMinutes(),
//     d1.getUTCSeconds()
//   );
//   return d2;
// }

/**
 * 金币显示
 */
// export function GolLimitMFormat(num, d = 2) {
//   const numb = num || 0;
//   // const numstr = Number(numb) / Math.pow(10, d);
//   const numstr = Number(numb);

//   // console.log(decimalPoint, thousandSeparator);
//   let amount = "";
//   if (numstr >= 10000000000) {
//     amount = parseFloat(numstr / 1000000000).toFixed(d) + "B";
//   } else if (numstr >= 10000000) {
//     amount = parseFloat(numstr / 1000000).toFixed(d) + "M";
//   } else {
//     amount = toNonExponential(numstr, d, true);
//     // amount = amount.replace(",", thousandSeparator);
//   }
//   return amount;
// }
export function GolLimitMFormat(num, d = 2) {
  const numb = Number(num) || 0;

  // 记录正负号
  const sign = numb < 0 ? "-" : "";

  // 统一按绝对值处理
  const absNum = Math.abs(numb);

  let amount = "";

  if (absNum >= 10000000000) {
    amount = (absNum / 1000000000).toFixed(d) + "B";
  } else if (absNum >= 10000000) {
    amount = (absNum / 1000000).toFixed(d) + "M";
  } else if (absNum >= 1000) {
    amount = (absNum / 1000).toFixed(d) + "K";
  } else {
    amount = toNonExponential(absNum, d, true);
  }

  // 最后加回符号
  return sign + amount;
}

export function replacePoint(val) {
  // 获取配置的语言千分位
  const packLanguages =
    vm.$store.getters.getPacketConfig?.packetInfo?.baseInfo?.packLanguages ||
    {};
  const languageConfig = packLanguages[vm.$store.getters.getLang] || {};
  const decimalPoint = languageConfig.decimalPoint || ".";
  const thousandSeparator = languageConfig.thousandSeparator || ",";
  const txt = val.replace(/,/g, "&");
  return txt.replace(".", decimalPoint).replace(/&/g, thousandSeparator);
}

// 检测两个对象key value 是否相同 不支持深度检测
export function areObjectsEqual(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Step 1: Check if both objects have the same keys
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Step 2: Check if values for each key are the same
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
}

export function isHome() {
  return window.location.pathname.includes("/home");
}

/**
 * 是游戏执行方法
 */
export function isGame() {
  const tiapzhuantype = window.location.pathname;
  return (
    tiapzhuantype.split("/other")[1] ||
    tiapzhuantype.split("/payGame")[1] ||
    tiapzhuantype.split("/games")[1]
  );
}

/**
 * 是游戏执行方法 不包括other
 */
export function isGameNotOther() {
  const tiapzhuantype = window.location.hash;
  return tiapzhuantype.split("/payGame")[1] || tiapzhuantype.split("/games")[1];
}

/**
 * 是三方游戏右路
 */
export function isOtherGame() {
  const tiapzhuantype = window.location.pathname;
  return tiapzhuantype.split("/other")[1];
}

/**
 * 金币显示
 */
export function numbrFormat(num, d = 2) {
  const numstr = Number(num) || 0;
  return parseFloat(numstr).toFixed(d);
}

/**
 * 判断是否为手机打开
 * @returns false/true
 */
export function isMobile() {
  // match方法可在字符串内检索指定的值，
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

/**
 * 判断是否为手机IOS打开
 * @returns false/true
 */
export function isIOS() {
  // match方法可在字符串内检索指定的值，
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad)/i
  );
  return flag;
}

// 是否是安卓
export function isAndroid() {
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf("android") > -1;
}

// 是否快捷方式进来的
export function isPWA() {
  return (
    window.navigator.standalone ||
    window.matchMedia("(display-mode: standalone)").matches
  );
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
// eslint-disable-next-line no-extend-native
Date.prototype.Format = function (fmt) {
  const o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
/**
 * 数字显示
 */
export function numberShow(num, d = 2) {
  const numstr = Number(num) || 0;
  const precision = Math.pow(10, d);
  return (numstr / precision).toFixed(d);
}

// 判断不是自研游戏
export function tiapzhuantype() {
  const tiapzhuantype = window.location.pathname;
  if (tiapzhuantype.split("/other")[1]) {
    return true;
  } else {
    return false;
  }
}

// 处理科学记数显示问题
function toNonExponential(num, d, isThousands) {
  const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
  const f = d || Math.max(0, (m[1] || "").length - m[2]);
  // return num.toFixed(f);
  // 金额千分位
  if (isThousands) return formatNumberWithCommas(num.toFixed(f));
  else return num.toFixed(f);
}

// 精度处理 /
// value: 金额, d: 精度, isNeedFormat: true 转千分符，是否需要千分位或M、B、K格式处理(佣金、流水、统计相关)
export function divideAccuracy(value, d = 2, isNeedFormat) {
  let money = 0;
  if (value !== "") money = Number(+value / Math.pow(10, d));
  if (!isNaN(money)) {
    if (isNeedFormat === true) {
      // true 转千分符、转符号、KMB
      return replacePoint(GolLimitMFormat(money, d));
    } else if (isNeedFormat === "point") {
      // point 转千分符、转符号
      return replacePoint(toNonExponential(money, d, true));
    } else {
      // 处理了精度后的原始数据
      return toNonExponential(money, d);
    }
  } else {
    return 0;
  }
}
// 精度处理 *
export function divideMultiply(value, d = 2) {
  let money = 0;
  if (value !== "") money = Number(+value * Math.pow(10, d));
  if (!isNaN(money)) return toNonExponential(money, d); // GolLimitMFormat
  else return 0;
}

// 直接处理千分位，转符号，不需要算精度
export function divideSymbol(value) {
  if (!isNaN(value)) return replacePoint(formatNumberWithCommas(value));
  else return value;
}
// 千分位处理
export function formatNumberWithCommas(val) {
  // if (parseFloat(val).toString() == "NaN") {
  //   return "";
  // }
  var parts = val.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

// 判断终端
export function isSafari() {
  const flag =
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
  return flag;
}

export function getUrlkey() {
  const geturl = window.location.href;
  const getqyinfo = geturl.split("?")[1];
  const obj = {}; // 创建空对象，接收截取的参数
  if (getqyinfo) {
    const getqys = getqyinfo.split("&");
    for (let i = 0; i < getqys.length; i++) {
      const item = getqys[i].split("=");
      const key = item[0];
      const value = item[1];
      obj[key] = value;
    }
    return obj;
  }
  return obj;
}
// 多语言传变量显示
export function formatLang(str, arr) {
  let _st = str;
  if (!arr || !arr.length) return _st || "";
  for (let i = 0; i < arr.length; ++i) {
    _st = _st.replace(/[Ss]%/, arr[i]);
  }
  return _st;
}

// 跳拼多多拉新功能弹窗
export const jumpPullNew = async () => {
  const { data, code } = await getNewUserHelpInfo({});
  if (code === 0 && data) {
    // console.log("data", data);
    let status = 1;
    if (data.startTime && data.startTime !== "0") {
      // 活动参与中
      status = 2; // 展示恭喜您...
    } else {
      // data.startTime === "0"
      if (data.completeStatus === 0) {
        // 未完成
        if (data.currentAmount && data.currentAmount !== "0") {
          // 72小时内未完成
          status = 3;
        } else {
          // 未参与活动
          status = 1;
        }
      } else if (data.completeStatus === 1) {
        // 完成活动了，但是72小时内未领取
        status = 4;
      } else {
        // data.completeStatus === 2 已领取
        status = 1;
      }
    }
    vm.$Bus.$emit("showPullNewModal", {
      pullNewInfo: {
        ...data,
        isStart: status,
      },
      show: true,
    });
  }
};

// 跳任务中心 独立功能
function jumpTaskCenter(item, isMobile) {
  if (!vm.$store.getters.login) {
    vm.$Bus.$emit("showLogin");
    return;
  }
  vm.$isPopShow({
    show: true,
    views: "newTask",
    data: {
      hideTitle: true,
      taskJump: item?.taskJump || null,
      backBtn: !!isMobile,
      position: item?.position || "",
    },
  });
}
// 跳充值红包
export const jumpRechargeGift = (item) => {
  if (!vm.$store.getters.login) {
    vm.$Bus.$emit("showLogin");
  } else {
    // 充值礼包
    vm.$isPopShow({
      show: true,
      views: "chargeEnvelope",
      fullscreen: false,
      data: {
        sid: item?.taskJump,
        SubGiftpack: "Features",
        title: "",
        width: "360px",
      },
    });
  }
};

// 跳功能弹窗
function jumpFuncModal(item, isMobile) {
  // enum JumpFunctionType {
  //   JUMP_FUNCTION_TYPE_ALL = 0;
  //   // 累计宝箱
  //   JUMP_FUNCTION_TYPE_ACCUMULATED_BOX = 1; ok
  //   // 宝箱奖励
  //   JUMP_FUNCTION_TYPE_REWARD_BOX = 2; ok
  //   // 充值系统
  //   JUMP_FUNCTION_TYPE_RECHARGE = 3; ok
  //   // 提现系统
  //   JUMP_FUNCTION_TYPE_WITHDRAW = 4; ok
  //   // 我的钱包
  //   JUMP_FUNCTION_TYPE_WALLET = 5;
  //   // 活动中心
  //   JUMP_FUNCTION_TYPE_ACTIVITY_CENTER = 7; ok
  //   // 任务中心
  //   JUMP_FUNCTION_TYPE_TASK_CENTER = 8; ok
  //   // VIP等级
  //   JUMP_FUNCTION_TYPE_VIP_LEVEL = 9; ok
  //   // 公告
  //   JUMP_FUNCTION_TYPE_NOTICE = 10; ok
  //   // 返水功能
  //   JUMP_FUNCTION_TYPE_WITHDRAW_RATE = 11;
  //   // 个人中心
  //   JUMP_FUNCTION_TYPE_PERSONAL_CENTER = 12;
  //   // 推广赚钱
  //   JUMP_FUNCTION_TYPE_PROMOTION = 13;
  //   // 邮件
  //   JUMP_FUNCTION_TYPE_MAIL = 14; ok
  //   // 品牌宣传
  //   JUMP_FUNCTION_TYPE_BRAND_ADVERTISING = 15;
  //   // 兑换码
  //   JUMP_FUNCTION_TYPE_EXCHANGE_CODE = 16; ok
  //   // 定时红包
  //   JUMP_FUNCTION_TYPE_TIMED_RED_PACKET = 17; ok
  //   // 账户管理
  //   JUMP_FunctionType_ACCOUNT_MANAGEMENT = 18; ok
  //   // 转盘
  //   JUMP_FUNCTION_TYPE_ROTARY_PLATE = 19; ok
  //   // 消息中心
  //   JUMP_FUNCTION_TYPE_MESSAGE_CENTER = 20;
  //   // 客服系统
  //   JUMP_FUNCTION_TYPE_CUSTOMER_SERVICE = 21;
  //   // 交易记录
  //   JUMP_FUNCTION_TYPE_TRADE_RECORD = 22;
  //   // 游戏记录
  //   JUMP_FUNCTION_TYPE_GAME_RECORD = 23;
  //   // 首充礼包 -app
  //   JUMP_FUNCTION_TYPE_FIRST_RECHARGE_GIFT_PACKAGE = 24; ok
  //   // 每日礼包- app
  //   JUMP_FUNCTION_TYPE_DAILY_GIFT_PACKAGE = 25; ok
  //   // 历史/收藏
  //   JUMP_FUNCTION_TYPE_HISTORY_COLLECTION = 26;已弃用
  //   // 打码排行榜
  //   JUMP_FUNCTION_TYPE_CODING_RANKING = 27;已弃用
  //   // 拉新助力
  //   JUMP_FUNCTION_TYPE_NEW_USER_ASSIST = 26; ok
  //   // 注册
  //   JUMP_FUNCTION_TYPE_REGISTER = 27;
  //   // 登录
  //   JUMP_FUNCTION_TYPE_LOGIN = 28;
  //   // 历史
  //   JUMP_FUNCTION_TYPE_HISTORY = 29;
  //   // 收藏
  //   JUMP_FUNCTION_TYPE_COLLECTION = 30;
  //   奥运竞猜
  //   JUMP_FUNCTION_TYPE_OLYMPIC_GUESS = 31;
  //   签到有礼
  //   JUMP_FUNCTION_TYPE_SIGN = 31;
  //  JUMP_FUNCTION_TYPE_FIRST_WITHDRAW_PROGRESS ; // 首次提现进度
  // 手机号绑定
  // JUMP_FUNCTION_TYPE_MOBILE_BINDING = 55;

  // }

  // jump_value: 1充值 2 全面推广 3 VIP等级 4 邮件 5 公告 6 签到 7 品宣 8提现   9 活动中心 10 下载app界面  11 任务中心 12历史收藏
  //  50好友邀请  51 首充  52 每日礼包   53 分享奖励 54绑定手机  55 兑换码 56 绑定facebook 57 账户管理 60 打榜 61转盘 64宝箱奖励 65累计宝箱奖励 66 定时红包
  if (!item.functionType || item.functionType === "JUMP_FUNCTION_TYPE_ALL") {
    return false;
  }

  if (item.functionType === "JUMP_FUNCTION_TYPE_MOBILE_BINDING") {
    const path = isMobile ? "/user/hAccountInfo" : "/user";
    vm.$router.push({
      path: path,
      query: { tab: "1" },
    });
    return false;
  }
  const titleStr = {
    17: vm.$t("Datalang.Event_TITLE_dailypack"),
    16: vm.$t("Datalang.Event_TITLE_fristrecharge"),
  };
  // 注册
  if (item.functionType === "JUMP_FUNCTION_TYPE_REGISTER") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin", { tab: "Register" });
    }
  }
  // 登录
  if (item.functionType === "JUMP_FUNCTION_TYPE_LOGIN") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin", { tab: "Login" });
    }
  }

  // 累计宝箱活动
  if (item.functionType === "JUMP_FUNCTION_TYPE_ACCUMULATED_BOX") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      const path = isMobile ? "/user/hDistribution" : "/user/distribution";
      if (location.href.includes(path)) {
        vm.$Bus.$emit("goGeneralPage", 11);
      } else {
        vm.$router.push({
          path: path,
          query: { index: 11 },
        });
      }
      // vm.$isPopShow({
      //   show: true,
      //   views: "totalTreasureBox",
      //   data: {
      //     title: vm.$t("Datalang.TreasureReward"),
      //     // width: "450px",
      //   },
      // });
    }
  }
  // 宝箱奖励
  if (item.functionType === "JUMP_FUNCTION_TYPE_REWARD_BOX") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      const path = isMobile ? "/user/hDistribution" : "/user/distribution";
      if (location.href.includes(path)) {
        vm.$Bus.$emit("goGeneralPage", 10);
      } else {
        vm.$router.push({
          path: path,
          query: { index: 10 },
        });
      }
      // vm.$isPopShow({
      //   show: true,
      //   views: "treasureBox",
      //   data: {
      //     title: vm.$t("Datalang.TreasureReward"),
      //     // width: "450px",
      //   },
      // });
    }
  }
  // 充值
  if (item.functionType === "JUMP_FUNCTION_TYPE_RECHARGE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$Bus.$emit("showCharge", { show: true });
    }
  }
  // 充值转盘
  if (item.functionType === "JUMP_FUNCTION_TYPE_RECHARGE_TURNTABLE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "rechargeTurntable",
        data: {
          backBtn: false,
          title: "",
          SubTurntable: "function",
        },
      });
    }
  }
  // 提现
  if (item.functionType === "JUMP_FUNCTION_TYPE_WITHDRAW") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
      return;
    }
    vm.$Bus.$emit("showExchange", { show: true });
  }

  // 我的钱包
  if (item.functionType === "JUMP_FUNCTION_TYPE_WALLET") {
    const path = isMobile ? "/user/hWallet" : "/user/wallet";
    vm.$router.push(path);
  }
  // 活动中心
  if (item.functionType === "JUMP_FUNCTION_TYPE_ACTIVITY_CENTER") {
    const path = isMobile ? "/hEvents" : "/events";
    vm.$router.push({
      path: path,
      query: {
        tab: 2,
        t: Date.now(),
      },
    });
  }
  // 奖金入口
  if (item.functionType === "JUMP_FUNCTION_TYPE_REWARD") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      const path = isMobile ? "/hEvents" : "/events";
      vm.$router.push({
        path: path,
        query: {
          tab: 1,
          t: Date.now(),
        },
      });
    }
  }
  // 任务中心
  if (item.functionType === "JUMP_FUNCTION_TYPE_TASK_CENTER") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      // const path = isMobile ? "/hEvents" : "/events";
      // vm.$router.push({
      //   path: path,
      //   query: {
      //     tab: 3,
      //     t: Date.now(),
      //   },
      // });
      vm.$isPopShow({
        show: true,
        views: "newTask",
        data: {
          hideTitle: true,
          backBtn: !!isMobile,
        },
      });
    }
  }
  // VIP等级
  if (item.functionType === "JUMP_FUNCTION_TYPE_VIP_LEVEL") {
    const path = isMobile ? "/user/hVip" : "/user/vip";
    vm.$router.push(path);
  }

  // 公告 (待确认)
  if (item.functionType === "JUMP_FUNCTION_TYPE_NOTICE") {
    const path = isMobile ? "/user/hNoticeCenter" : "/user/notice";
    vm.$router.push(path);
  }

  // 返水功能 (待做)
  if (item.functionType === "JUMP_FUNCTION_TYPE_WITHDRAW_RATE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "fanshui",
        data: {
          title: vm.$t("Datalang.newly_rebate_function"),
        },
      });
    }
  }

  // 个人中心
  if (item.functionType === "JUMP_FUNCTION_TYPE_PERSONAL_CENTER") {
    const path = isMobile ? "/userCenter" : "/user";
    vm.$router.push(path);
  }

  // 推广赚钱
  if (item.functionType === "JUMP_FUNCTION_TYPE_PROMOTION") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      const path = isMobile ? "/user/hDistribution" : "/user/distribution";
      if (location.href.includes(path)) {
        vm.$Bus.$emit("goGeneralPage", 1);
      } else {
        vm.$router.push({
          path: path,
          query: { index: 1 },
        });
      }
    }
  }

  // 邮件
  if (item.functionType === "JUMP_FUNCTION_TYPE_MAIL") {
    const path = isMobile ? "/user/hNoticeCenter" : "/user/notice";
    vm.$router.push(path);
  }
  // 品牌宣传 (待做)
  // if (item.functionType === "JUMP_FUNCTION_TYPE_BRAND_ADVERTISING") {
  // }

  // 兑换码
  if (item.functionType === "JUMP_FUNCTION_TYPE_EXCHANGE_CODE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "redeemCode",
        fullscreen: false,
        data: {
          backBtn: true,
          title: vm.$t("Datalang.Event_TIP_redemptionsuccesscode"),
        },
      });
    }
  }

  // 定时红包
  if (item.functionType === "JUMP_FUNCTION_TYPE_TIMED_RED_PACKET") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "redeemTime",
        fullscreen: false,
        data: {
          title: vm.$t("Datalang.Scheduled_Red_Packets"),
        },
      });
    }
  }

  // 账户管理
  if (item.functionType === "JUMP_FunctionType_ACCOUNT_MANAGEMENT") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
      return;
    }
    vm.$isPopShow({
      show: true,
      views: "accountAddress",
      data: {
        title: vm.$t("Datalang.Withdrawl_BTM_accountmanagement"),
        // width: "900px",
      },
    });
  }

  // 转盘
  if (item.functionType === "JUMP_FUNCTION_TYPE_ROTARY_PLATE") {
    vm.$isPopShow({
      show: true,
      views: "turntable",
      data: {
        backBtn: true,
        title: "",
        width: "450px",
      },
    });
  }

  // 消息中心
  if (item.functionType === "JUMP_FUNCTION_TYPE_MESSAGE_CENTER") {
    const path = isMobile ? "/user/hNoticeCenter" : "/user/notice";
    vm.$router.push(path);
  }
  // 客服系统
  if (item.functionType === "JUMP_FUNCTION_TYPE_CUSTOMER_SERVICE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$Bus.$emit("goKehu");
    }
  }

  // 交易记录
  if (item.functionType === "JUMP_FUNCTION_TYPE_TRADE_RECORD") {
    const path = isMobile ? "/user/hWalletRecord" : "/user/walletRecord";
    vm.$router.push(path);
  }

  // 游戏记录
  if (item.functionType === "JUMP_FUNCTION_TYPE_GAME_RECORD") {
    const path = isMobile ? "/user/hGameRecord" : "/user/gameRecord";
    vm.$router.push(path);
  }

  // 首充礼包
  if (item.functionType === "JUMP_FUNCTION_TYPE_FIRST_RECHARGE_GIFT_PACKAGE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "everyDayGift",
        data: {
          title: titleStr[16],
          width: "1024px",
          data: {
            type: 16,
          },
        },
      });
    }
  }
  // 每日礼包
  if (item.functionType === "JUMP_FUNCTION_TYPE_DAILY_GIFT_PACKAGE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "everyDayGift",
        data: {
          title: titleStr[17],
          width: "1024px",
          data: {
            type: 17,
          },
        },
      });
    }
  }

  // 拼多多拉新助力
  if (item.functionType === "JUMP_FUNCTION_TYPE_NEW_USER_ASSIST") {
    // const path = isMobile ? "/user/hReward" : "/reward";
    // vm.$router.push(path);
    jumpPullNew();
    return;
  }
  // // 收藏历史
  // if (item.functionType === "JUMP_FUNCTION_TYPE_HISTORY_COLLECTION") {
  //   vm.$router.push("/history");
  // }
  // 历史
  if (item.functionType === "JUMP_FUNCTION_TYPE_HISTORY") {
    vm.$router.push("/history");
  }
  // 收藏
  if (item.functionType === "JUMP_FUNCTION_TYPE_COLLECTION") {
    vm.$router.push("/history?type=1");
  }
  // 奥运竞猜
  if (item.functionType === "JUMP_FUNCTION_TYPE_OLYMPIC_GUESS") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
      return;
    }
    vm.$isPopShow({
      show: true,
      views: "olympicGames",
      data: {
        title: vm.$t("Datalang.olympic_Betting"),
        width: "800px",
      },
    });
  }
  // 签到有礼
  if (item.functionType === "JUMP_FUNCTION_TYPE_SIGN") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      // 签到 -
      vm.$isPopShow({
        show: true,
        views: "signGift",
        data: {
          // title: vm.$t("签到有礼"),
          backBtn: true,
          title: "",
          width: "1000px",
        },
      });
    }
  }
  // 周月卡
  if (item.functionType === "JUMP_FUNCTION_TYPE_WEEK_MONTH_CARD") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "weekMonthCard",
        data: {
          title: "",
          width: "1000px",
        },
      });
    }
  }

  // VIP转盘
  if (item.functionType === "JUMP_FUNCTION_TYPE_VIP_TURNTABLE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      // VIP转盘
      vm.$isPopShow({
        show: true,
        views: "turntableVip",
        data: {
          title: "",
          width: "1100px",
          close: true,
        },
      });
    }
  }
  // 利息宝
  if (item.functionType === "JUMP_FUNCTION_TYPE_INTEREST_TREASURE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "interestTreasure",
        fullscreen: false,
        data: {
          backBtn: true,
          title: vm.$t("Datalang.home_interest"),
          width: "1000px",
        },
      });
    }
  }
  // 排行榜弹窗
  if (item.functionType === "JUMP_FUNCTION_TYPE_CODE_RANK_POP") {
    vm.$isPopShow({
      show: true,
      views: "RankMode2",
      fullscreen: false,
      data: {
        backBtn: true,
        title: vm.$t("Datalang.Invite_BTM_rankings"),
        width: "1000px",
      },
    });
  }
  // 排行榜页面
  if (item.functionType === "JUMP_FUNCTION_TYPE_CODE_RANK") {
    vm.$router.push({
      path: "/rankPage",
      query: { index: item.index || 1 },
    });
  }
  // 首页
  if (item.functionType === "JUMP_FUNCTION_TYPE_HOMEPAGE") {
    vm.$router.push("/home");
  }
  // 副首页
  if (item.functionType === "JUMP_FUNCTION_TYPE_HOMEPAGE_SECOND") {
    vm.$router.push("/viceHome");
  }
  // 下载页
  if (item.functionType === "JUMP_FUNCTION_TYPE_DOWNLOAD_PAGE") {
    const path = isMobile ? "/hPromote" : "/promote";
    vm.$router.push(path);
  }
  // 菜单
  if (item.functionType === "JUMP_FUNCTION_TYPE_MENU") {
    vm.$store.dispatch("setMenuBar", !vm.$store.getters.menuIsShow);
  }
  // 神秘奖励
  if (item.functionType === "JUMP_FUNCTION_TYPE_MYSTERIOUS_REWARDS") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$Bus.$emit("showMysteriousRewards");
    }
  }
  // 集卡活动
  if (item.functionType === "JUMP_FUNCTION_TYPE_COLLECT_CARD") {
    // JUMP_FUNCTION_TYPE_COLLECT_CARD
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$Bus.$emit("showCollectCard");
    }
  }
  // 冲榜活动
  if (item.functionType === "JUMP_FUNCTION_TYPE_MULTI_RUSH_RANK") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$Bus.$emit("showMultiRushBank");
    }
  }

  // 首次提现进度
  if (item.functionType === "JUMP_FUNCTION_TYPE_FIRST_WITHDRAW_PROGRESS") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      // console.log("首次提现进度");
      // hotfix-0815 注释掉首提弹窗
      // FirstWithdrawalProgress();
    }
  }
  // 去下载页
  if (item.functionType === "JUMP_FUNCTION_TYPE_DOWNLOAD_PAGE") {
    vm.$router.push("/promote");
  }
  // 限时优惠
  if (item.functionType === "JUMP_FUNCTION_TYPE_LIMITED_TIME_DISCOUNT") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$Bus.$emit("showCharge", { show: true });
    }
  }
  // 奖励列表弹窗
  if (item.functionType === "JUMP_FUNCTION_TYPE_REWARD_LIST_POPUP") {
    vm.$isPopShow({
      show: true,
      views: "freeAmount",
      fullscreen: false,
      data: {
        title: vm.$t("Datalang.newly_list_popup"),
        width: "340px",
      },
    });
  }
  // 快速登录
  if (item.functionType === "JUMP_FUNCTION_TYPE_QUICK_LOGIN") {
    // JUMP_FUNCTION_TYPE_QUICK_LOGIN
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("quickLoginJump");
    }
  }
  // 反馈
  if (item.functionType === "JUMP_FUNCTION_TYPE_FEEDBACK") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$router.push("/user/hFeedBack");
    }
  }
  // 个人资料
  if (item.functionType === "JUMP_FUNCTION_TYPE_PROFILE") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$router.push("/user/hAccountInfo");
    }
  }
  // 免费金币提现
  if (item.functionType === "JUMP_FUNCTION_TYPE_REDEEM_FREE_COIN") {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      // 免费金币提现
      vm.$Bus.$emit("showFreeExchange", { show: true });
    }
  }
  // 充值解锁免费提现
  if (
    item.functionType === "JUMP_FUNCTION_TYPE_RECHARGE_UNLOCK_FREE_WITHDRAW"
  ) {
    if (!vm.$store.getters.login) {
      vm.$Bus.$emit("showLogin");
    } else {
      vm.$isPopShow({
        show: true,
        views: "rechargeToUnlock",
        data: {
          hideTitle: true,
          backBtn: !!isMobile,
        },
      });
    }
  }
}

// 跳单款游戏
async function jumpGame(item) {
  let opt = {};
  try {
    const { code, data } = await getGameGroupBySid({
      gameGroupSid: item.game?.gameGroupSid,
    });
    if (code === 0) {
      opt = data || {};
      vm.$store.commit("setRecordGame", opt);
    }
  } catch (error) {
    console.log(error);
  }
  payGameFun(opt, 2);
}

// 跳链接
function jumpWebUrl(item, isMobile) {
  // 站内
  if (item.type === "Jump_TYPE_SITE_LINK") {
    vm.$popConfig.endWinConfig();
    if (item.siteLink?.web) {
      const href = item.siteLink?.web.replace(/ /g, "");
      vm.$router.push(href);
    }
  } else {
    // 站外
    const href = item.offsiteLink?.replace(/ /g, "");
    if (isMobile) {
      if (window?.Telegram?.WebApp?.openLink) {
        window.Telegram.WebApp.openLink(href);
      } else {
        TelegramUtil.hideBackButton();
        // window.location.href = href;
        locationJump(href);
      }
    } else {
      window.open(href, "_blank");
    }
  }
}

// 跳活动
function jumpActivity(item, isMobile) {
  // 活动
  let path = isMobile ? "/hactivityDetail/" : "/activityDetail/";
  if (item.activitySid) {
    // 活动id
    path = path + item.activitySid;
    vm.$router.push(path);
  } else {
    // 活动类型 type
    vm.$router.push({
      path: path,
      query: { type: item.activityType },
    });
  }
}

// 视频内嵌地址
function jumpIframeLink(item, isMobile) {
  // console.log(item, "11111111111111");
  vm.$router.push({
    path: "/video",
    query: { id: encodeBase64(item?.siteLink?.web) || "" },
  });
}
// 任务礼包展示
function jumpGiftTask(item, isMobile) {
  console.log("11111111", item);
  if (!vm.$store.getters.login) {
    vm.$Bus.$emit("showLogin");
  } else {
    vm.$isPopShow({
      show: true,
      views: "rewardTask",
      data: {
        hideTitle: true,
        backBtn: true,
        taskJump: item?.taskJump || null,
      },
    });
  }
}
// 跳副首页
function jumpViceHome(item, isMobile) {
  vm.$router.push({
    path: "/viceHome",
    query: { templateSid: item.templateSid },
  });
}

// 跳兑换码
function jumpExchangeCode(item, isMobile) {
  if (!vm.$store.getters.login) {
    vm.$Bus.$emit("showLogin");
  } else {
    // 领取兑换码
    // 领取兑换码
    ExchangeCode(item);
    // item?.callback?.();
  }
}
//  全局兑换码跳转
export async function ExchangeCode(item) {
  const { code, data } = await redRedeemCodeReceive({
    redeemCode: item?.exchangeCode,
  });
  if (code === 0) {
    const rewardType = data?.rewardType || "ACTIVITY_REWARD_TYPE_MONEY"; // 奖励类型 默认金额奖励
    if (rewardType === "ACTIVITY_REWARD_TYPE_MONEY") {
      const taskSuccess = {
        bonusAmount: data?.bonusAmount,
        accuracy: data?.accuracy,
        coinCode: data?.coinCode,
      };
      vm.$Bus.$emit("taskSuccess", taskSuccess);
      return;
    } else {
      console.log("兑换码跳转");
      vm.$Bus.$emit("rewardTipsShow", data);
    }
  }
}
// 跳转游戏组
function jumpGameGroup(item) {
  const { secondaryJump1, secondaryJump2, jumpName1, jumpName2 } =
    item?.multipleGame;

  if (secondaryJump1) {
    vm.$router.push({
      name: "gameList",
      query: {
        brandId: secondaryJump1 || "",
        nav: secondaryJump2 || "",
        title: encodeURIComponent(jumpName1) || "",
      },
    });
  }
}

// 活动中心  活动详情跳转对应活动
// 无：Jump_TYPE_ALL  活动：Jump_TYPE_ACTIVITY  功能：Jump_TYPE_FUNCTION
// 单款游戏：Jump_TYPE_GAME   多款游戏（在goJoinEvent方法外已处理）：Jump_TYPE_MULTIPLE_GAME
// 站内链接：Jump_TYPE_SITE_LINK    站外链接：Jump_TYPE_OFFSITE_LINK
export async function goJoinEvent(item = {}, getIsMobile, oldDetail = {}) {
  // item 跳转信息
  console.log(item, "jumpInfo");
  const isMobile = getIsMobile || vm.$store?.getters?.getIsMobile;
  // 调试 跳功能-兑换码
  // return false
  switch (item.type) {
    case "Jump_TYPE_ALL": // 无
      break;
    case "Jump_TYPE_GAME": // 单款游戏
      jumpGame(item);
      break;
    case "Jump_TYPE_ACTIVITY": // 活动 跳活动中心详情
      jumpActivity(item, isMobile);
      break;
    case "Jump_TYPE_FUNCTION": // 功能
      jumpFuncModal(item, isMobile);
      break;
    case "JUMP_TYPE_TASK_CENTER": // 任务中心
      jumpTaskCenter(item, isMobile);
      break;
    case "JUMP_TYPE_RECHARGE_GIFT": // 充值红包
      jumpRechargeGift(item, isMobile);
      break;
    case "Jump_TYPE_SITE_LINK": // 站内链接
      jumpWebUrl(item, isMobile);
      break;
    case "Jump_TYPE_OFFSITE_LINK": // 站外链接
      jumpWebUrl(item, isMobile);
      break;
    case "JUMP_TYPE_TEMPLATE": // 副首页
      jumpViceHome(item, isMobile);
      break;
    case "JUMP_TYPE_EXCHANGE_CODE": // 兑换码
      jumpExchangeCode(item, isMobile);
      break;
    case "Jump_TYPE_MULTIPLE_GAME": // 游戏组
      jumpGameGroup(item, isMobile);
      break;
    case "JUMP_TYPE_IFRAME_LINK": // iframe资源连接视频
      jumpIframeLink(item, isMobile);
      break;
    case "JUMP_TYPE_GIFT_TASK": //  礼包任务
      jumpGiftTask(item, isMobile);
      break;
  }
}

// 页面渐入渐出
export function opacityPage(dom) {
  dom.animate(
    [
      {
        opacity: "1",
      },
    ],
    {
      duration: 1500, // 持续时间
      easing: "linear", // 规定动画的速度曲线
      delay: 1, // 在动画开始之前
      fill: "forwards", // 动画是否停在最后一个关键帧
    }
  );
}

// 获取当前时间的美东时间 2012-12-02  示例
// export function getTodayAmericaEastTime() {
//   const currentDate = new Date();
//   const options = { timeZone: "America/New_York" };
//   const easternTime = currentDate.toLocaleString("en-US", options);
//   const time = new Date(easternTime);
//   return time.Format("yyyy-MM-dd");
// }

// 调用 cocos 客户端 通信
export function toCocosFun(data) {
  // 关闭窗口
  const params = getUrlkey();
  try {
    if (params.devicesType == "iOS") {
      window["webkit"] &&
        window["webkit"].messageHandlers &&
        window["webkit"].messageHandlers.sendMessageToCocos &&
        window["webkit"].messageHandlers.sendMessageToCocos.postMessage(
          JSON.stringify(data)
        );
    } else {
      window["AndroidApp"] &&
        window["AndroidApp"].sendMessageToCocos &&
        window["AndroidApp"].sendMessageToCocos(JSON.stringify(data));
    }
  } catch (error) {
    console.log(error, "-----调用 cocos 客户端错误");
  }
}
// 调用 cocos 客户端 下载
export function cocosDownload(text) {
  toCocosFun({
    key: "download",
    value: text,
  });
}

// 分享方法
export function goShareInstagram(shareUrl, content) {
  const href = "https://www.instagram.com";
  if (isMobile()) {
    copyFun(
      `${content}
        ${shareUrl}`,
      "",
      false
    );
  }
  createA(href);
}
export function goShareLINE(shareUrl) {
  const href = `http://line.naver.jp/R/msg/text/?${shareUrl}`;
  createA(href);
}
export function goShare1(shareUrl, content) {
  const href = `https://t.me/share/url?url=${encodeURIComponent(
    shareUrl
  )}&text=${encodeURIComponent(content)}`;
  createA(href, "t");
}
export function goShare2(shareUrl, content) {
  const contentEc = encodeURIComponent(content);
  const shareUrlEc = encodeURIComponent(shareUrl);
  const href = `https://twitter.com/intent/tweet?text=${contentEc}&url=${shareUrlEc}`;
  createA(href);
}
export function goShare3(shareUrl, content) {
  copyFun(
    `${content}
        ${shareUrl}`,
    "",
    false
  );
  if (isMobile() && isIOS()) {
    // location.href = "fb://share/?link=" + encodeURIComponent(shareUrl);
    locationJump("fb://share/?link=" + encodeURIComponent(shareUrl));
  }
  setTimeout(() => {
    const href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl
    )}`;
    createA(href);
  }, 1000);
}
export function goShare4(shareUrl, content) {
  const href = `https://wa.me/?text=${content} ${shareUrl}`;
  createA(href);
}
// 分享TikTok 链接
export function goShareTikTok(shareUrl, content) {
  const href = `https://www.tiktok.com/?text=${content} ${shareUrl}`;
  createA(href);
}
// 分享 Kwai
export function goShareKwai(shareUrl, content) {
  const href = `https://www.kwai.com/?content=${content} ${shareUrl}`;
  createA(href);
}
// 超链接
export function createA(href, type = null) {
  const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));
  // 马甲包
  if (isFromApp) {
    window.open(href);
  } else if (isFromApp && isIOS()) {
    // window.location.href = href;
    locationJump(href);
  } else if (isMobile()) {
    if (type !== "t") {
      TelegramUtil.hideBackButton();
    }
    if (window?.Telegram?.WebApp?.openLink && type !== "t") {
      window.Telegram.WebApp.openLink(href);
    } else {
      // 或者移动端
      // window.location.href = href;
      locationJump(href);
    }
  } else {
    // pc
    window.open(href);
  }
}

const ivKEY = "714526BB776E4BAF";
// aes 加密
export async function aesEntry(text) {
  // 密钥
  const key = "714526BB776E4BAF";

  // 将密钥转换为 ArrayBuffer
  const keyBuffer = new TextEncoder().encode(key);

  // 要加密的文本
  const textEncoder = new TextEncoder();
  const data = textEncoder.encode(text);

  // 生成随机的 Initialization Vector (IV)
  // const iv = window.crypto.getRandomValues(new Uint8Array(16));
  const iv = new TextEncoder().encode(ivKEY).slice(0, 16);

  // 导入密钥
  return window.crypto.subtle
    .importKey("raw", keyBuffer, { name: "AES-CBC" }, false, [
      "encrypt",
      "decrypt",
    ])
    .then((cryptoKey) => {
      // 使用 AES-CBC 加密
      return window.crypto.subtle
        .encrypt({ name: "AES-CBC", iv: iv }, cryptoKey, data)
        .then((encryptedData) => {
          // 将加密后的数据和 IV 转换为 Base64 编码的字符串
          const encryptedDataString = btoa(
            String.fromCharCode(...new Uint8Array(encryptedData))
          );
          const ivString = btoa(String.fromCharCode(...iv));

          // console.log("Original Text:", text);
          // console.log("Encrypted Data:", encryptedDataString);
          // console.log("IV:", ivString);

          return encryptedDataString;
        })
        .catch((error) => {
          console.error("Error encrypting data:", error);
        });
    })
    .catch((error) => {
      console.error("Error importing key:", error);
    });
}

export function qsStringify(data) {
  let queryString = "";
  if (typeof data !== "object" || data === null) {
    return queryString;
  }
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        value.forEach((val) => {
          queryString += `${encodeURIComponent(key)}=${encodeURIComponent(
            val
          )}&`;
        });
      } else {
        queryString += `${encodeURIComponent(key)}=${encodeURIComponent(
          value
        )}&`;
      }
    }
  }
  // 去除末尾的 '&'
  queryString = queryString.slice(0, -1);
  return queryString;
}
//  美东时间时间戳 10位
export function getAnyZoneStamp(timeStamp) {
  return getAppTimeStamp(timeStamp);
  // console.log(timeStamp, "timeStamp");
  // const timeStampTmp = getAnyZoneTimeStamp(timeStamp);
  // console.log(timeStampTmp, "timeStampTmp-------------");
  // return Math.floor(timeStampTmp / 1000);
}

//  淡入动画效果
export function fadeInAnimate(dom) {
  if (!dom) return false;
  dom.style.opacity = "0";
  dom.animate(
    [
      {
        opacity: "1",
      },
    ],
    {
      duration: 1500, // 持续时间
      easing: "linear", // 规定动画的速度曲线
      delay: 1, // 在动画开始之前
      fill: "forwards", // 动画是否停在最后一个关键帧
    }
  );
}

// 初始化IndexedDB
function initUtilsIndexedDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("commonDb", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("dataStore")) {
        const store = db.createObjectStore("dataStore", { keyPath: "id" });
      }
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      resolve(db);
    };

    request.onerror = (event) => {
      console.error("Error opening IndexedDB", event.target.error);
      reject(event.target.error);
    };
  });
}

// 保存数据到IndexDB 数据共享到ws
export function saveDataToIndexedDB(key, data) {
  initUtilsIndexedDB()
    .then((db) => {
      const transaction = db.transaction("dataStore", "readwrite");
      const store = transaction.objectStore("dataStore");
      store.put({ id: key, data: data });
    })
    .catch((error) => {
      console.error("Error saving to IndexedDB", error);
    });
}

// 从IndexDB中读数据
export function getDataFromIndexedDB(key) {
  return new Promise((resolve, reject) => {
    initUtilsIndexedDB()
      .then((db) => {
        const transaction = db.transaction("dataStore", "readonly");
        const store = transaction.objectStore("dataStore");

        const getRequest = store.get(key);
        getRequest.onsuccess = (event) => {
          const data = event.target.result;
          resolve(data);
        };

        getRequest.onerror = (event) => {
          console.error(
            "Error getting data from IndexedDB",
            event.target.error
          );
          reject(event.target.error);
        };
      })
      .catch((error) => {
        console.error("Error initializing IndexedDB", error);
        reject(error);
      });
  });
}

/**
 * 从 IndexedDB 中删除指定的记录
 * @param {string} id - 要删除的记录的 id
 * @returns {Promise<void>} - 一个 Promise 对象，表示删除操作的结果
 */
export function removeDataFromIndexDB(id) {
  return new Promise((resolve, reject) => {
    initUtilsIndexedDB()
      .then((db) => {
        // 开始事务
        const transaction = db.transaction("dataStore", "readwrite");
        const objectStore = transaction.objectStore("dataStore");

        // 删除数据
        const deleteRequest = objectStore.delete(id);

        deleteRequest.onsuccess = function () {
          console.log(`Data with id ${id} has been deleted.`);
          resolve();
        };

        deleteRequest.onerror = function (event) {
          console.error("Error deleting data:", event.target.error);
          reject(event.target.error);
        };
      })
      .catch((error) => {
        console.error("Error initializing IndexedDB for deletion:", error);
        reject(error);
      });
  });
}

// 底部模板排序
export function groupBy(array, key) {
  return array.reduce((result, currentItem) => {
    // 使用 key 函数提取分组键，如果提供了一个函数，则调用它
    const groupKey =
      typeof key === "function" ? key(currentItem) : currentItem[key];
    // 初始化分组数组（如果尚不存在）
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    // 将当前项添加到分组数组
    result[groupKey].push(currentItem);
    return result;
  }, {});
}

export function changeFooterData(
  arr,
  lineKey = "locationLine",
  columnKey = "locationColumn",
  columnValue = "STATUS_BOOL_TRUE"
) {
  // lineKey 第几行    columnKey 是否换行
  let reArr = []; // 返回数据
  const stArr = arr.map((v) => {
    // 初始数据
    const obj = { ...v };
    return obj;
  });
  const groupObj = groupBy(stArr, lineKey); // 根据key1分组返回对象
  reArr = Object.values(groupObj);
  // 根据key2合并数组数据
  reArr = reArr.map((reArrItem) => {
    let childArr = [];
    // 截取数组的切割点数据 从索引1开始
    const indexArr = [];
    reArrItem.map((v, index) => {
      // 从索引1开始
      if (index > 0 && v[columnKey] === columnValue) {
        indexArr.push(index);
      }
    });
    if (indexArr.length === 0) {
      // 无切割点
      childArr = [[...reArrItem]];
    } else {
      // 有切割点
      let curIndex = 0; // 记录切割起点
      indexArr.map((v, index) => {
        childArr.push(reArrItem.slice(curIndex, v));
        curIndex = v;
        if (index === indexArr.length - 1) {
          childArr.push(reArrItem.slice(v));
        }
      });
    }
    return childArr;
  });

  return reArr;
}

// 随机生成32位key
export function generateKey() {
  // 获取当前时间戳（毫秒）
  const timestamp = Date.now().toString(16); // 转换为16进制
  // 生成一个16字符的随机数
  const randomStr = "xxxxxxxxxxxxxxxx".replace(/[x]/g, function () {
    return ((Math.random() * 16) | 0).toString(16); // 随机生成16进制数
  });

  // 拼接时间戳和随机数生成32位key
  const uniqueKey = (timestamp + randomStr).slice(0, 32); // 确保key长度为32位
  // const ua = navigator.userAgent;
  // appName: navigator.appName,            // 浏览器名称
  // appVersion: navigator.appVersion,      // 浏览器版本
  // userAgent: ua,                         // 浏览器用户代理字符串
  // platform: navigator.platform,          // 操作系统平台
  // vendor: navigator.vendor,              // 浏览器供应商
  // language: navigator.language,          // 浏览器语言
  // isOnline: navigator.onLine             // 网络连接状态

  // const   appName= navigator.appName+'/'+navigator.appVersion+'/'+ua+'/'+navigator.platform+'/'+ navigator.language+'/'+navigator.onLine;         // 浏览器名称
  const appName = `${navigator.appName}/${navigator.appVersion}/${navigator.platform}/${navigator.language}/${navigator.onLine}`;
  return { murmur: uniqueKey, browser: appName };
}

// 获取手机型号版本
export function getapp_mobile() {
  const userAgent = navigator.userAgent;
  // 检测 Android 设备型号
  if (/android/i.test(userAgent)) {
    const match = userAgent.match(/Android\s+([\d.]+);\s+([^;\)]+)[;\)]/i);
    if (match) {
      return {
        os: "Android",
        version: match[1],
        model: match[2], // 设备型号
      };
    }
  }

  // 检测 iOS 设备型号
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    const match = userAgent.match(/\(([^)]+)\)/);
    if (match) {
      return {
        os: "iOS",
        model: match[1], // 设备型号
      };
    }
  }
  // 检测浏览器版本
  if (/Chrome\/([0-9.]+)/.test(userAgent)) {
    return {
      os: "Chrome",
      model: userAgent.match(/Chrome\/([0-9.]+)/)[1], // 设备型号
    };
  } else if (/Firefox\/([0-9.]+)/.test(userAgent)) {
    return {
      os: "Firefox",
      model: userAgent.match(/Firefox\/([0-9.]+)/)[1], // 设备型号
    };
    // result.browser = "Firefox";
    // result.browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)[1];
  } else if (/Safari\/([0-9.]+)/.test(userAgent) && !/Chrome/.test(userAgent)) {
    return {
      os: "Safari",
      model: userAgent.match(/Version\/([0-9.]+)/)[1], // 设备型号
    };
    // result.browser = "Safari";
    // result.browserVersion = userAgent.match(/Version\/([0-9.]+)/)[1];
  } else if (/Edge\/([0-9.]+)/.test(userAgent)) {
    return {
      os: "Edge",
      model: userAgent.match(/Edge\/([0-9.]+)/)[1], // 设备型号
    };
    // result.browser = "Edge";
    // result.browserVersion = userAgent.match(/Edge\/([0-9.]+)/)[1];
  } else if (/OPR\/([0-9.]+)/.test(userAgent)) {
    return {
      os: "Edge",
      model: userAgent.match(/OPR\/([0-9.]+)/)[1], // 设备型号
    };
    // result.browser = "Opera";
    // result.browserVersion = userAgent.match(/OPR\/([0-9.]+)/)[1];
  }

  return {
    os: "Unknown",
    model: "Unknown",
  };
}

// 判断是否是从PWA包、马甲包、轻量包、 快捷方式通过这四个进入的，默认不使用H5限制
// h5限制
// enum H5Limit {
//   // H5限制 默认
//   H5_LIMIT_DEFAULT = 0;
//   // H5限制 充值
//   H5_LIMIT_RECHARGE = 1;
//   // H5限制 提现
//   H5_LIMIT_WITHDRAW = 2;
//   // H5限制 玩游戏
//   H5_LIMIT_PLAY_GAME = 3;
// }
export function showDownloadDrawer(type, closeDialog) {
  if (!isMobile()) return false;
  // 是否是有渠道来源
  const terminaltype = localStorage.getItem("terminaltype") || "normal";
  if (terminaltype && terminaltype !== "normal") return false;
  // 是否来源马甲包
  const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));
  if (isFromApp) return false;
  const baseInfo =
    vm.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
  const h5Limit =
    baseInfo.h5Limit && baseInfo.h5Limit.length ? baseInfo.h5Limit : [];
  // const h5Limit = "H5_LIMIT_RECHARGE";

  // console.log("isMobile:", isMobile(), "h5Limit:", h5Limit);
  // console.log("terminaltype", terminaltype);
  // 不限制
  if (!h5Limit.includes(type)) {
    return false;
  }
  const siteConfig = vm.$store.getters.getPacketConfig?.site || {};
  // console.log("siteConfig", siteConfig);
  const pwaIcon = siteConfig.desktopSmallIcon;
  // const bootStatus = siteConfig.desktopSwitch === "ROW_STATUS_ENABLE";
  const systemType = systemCheck();
  let isShow = false;
  if (systemType === "ios" && !navigator.standalone) {
    isShow = true;
  }
  if (
    systemType === "android" &&
    !window.matchMedia("(display-mode: standalone)").matches
  ) {
    isShow = true;
  }
  if (isShow) {
    dynamicCreateManifest(siteConfig);
    const text = vm.$t("Datalang.home_For_the2");
    vm.$confirm(text, vm.$t("Datalang.home_Tips"), {
      confirmButtonText: vm.$t("Datalang.home_Go_to"),
      showCancelButton: false,
      showClose: false,
      closeOnClickModal: false,
    })
      .then(async () => {
        if (
          (systemType === "ios" &&
            siteConfig.iosType === "PACK_TYPE_DESKTOP_QUICK") ||
          (systemType === "android" &&
            (siteConfig.androidType === "PACK_TYPE_DESKTOP_QUICK" ||
              !siteConfig.androidAddr))
        ) {
          // 快捷方式引导
          vm.$Bus.$emit("showH5DownloadGuide", {
            pwaIcon,
            systemCheck: systemType,
          });
        } else {
          // 跳转下载页面
          if (type === "H5_LIMIT_RECHARGE") {
            vm.$Bus.$emit("showCharge", { show: false, closeDialog: true });
          } else if (type === "H5_LIMIT_WITHDRAW") {
            vm.$Bus.$emit("showExchange", { show: false, closeDialog: true });
          } else {
            if (closeDialog) {
              vm.$isPopShow({ show: false, views: "" });
            }
          }
          vm.$router.push("/user/hPromote");
        }
      })
      .catch(() => {});
    return true;
  }
  return false;
}

export function systemCheck() {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端.
  if (isAndroid) {
    return "android";
  }
  if (isIOS) {
    return "ios";
  }
}

const typeMap = {
  // 自定义类型
  recharge: 1, // 充值奖励
  task: 2, // 任务奖励
  vipReward: 3, // VIP奖励
  rebate: 4, // 现金返还
  turntable: 5, // 幸运转盘
  interestTreasure: 6, // 利息宝
  sign: 7, // 签到活动
  betRank: 8, // 打码排行榜
  timingRedEnvelope: 9, // 定时红包
  userHelpAssist: 10, // 拉新助力
  normalPrecious: 11, // 宝箱奖励
  grandPrecious: 12, // 累计宝箱
  tertiaryReward: 13, // 三级分销
  unlimitedReward: 14, // 全民推广
  promoteRechargeReward: 15, // 推广充值返利
};
const tomorrowType = [
  "rebate",
  "tertiaryReward",
  "unlimitedReward",
  "normalPrecious",
];

// 破产引导、首充、复充
export async function showPreviewRechargeReward(type, position) {
  if (!vm.$store.getters.login || !type) {
    vm.$popConfig.winConfigNext();
    return;
  }
  let isTipGame = false;
  // 引导每日最多触发5次,改成1次
  const chargeLuckyGuide = JSON.parse(
    localStorage.getItem("chargeLuckyGuide") || "{}"
  );
  const time = Number(chargeLuckyGuide.time || 0);
  const count = Number(chargeLuckyGuide.count || 0);
  const { firstTimeStampe, lastTimeStampe } = getDateLastTimeStampe();
  // if (
  //   time < firstTimeStampe ||
  //   time >= lastTimeStampe ||
  //   (time >= firstTimeStampe && time < lastTimeStampe && count < 1)
  // ) {
  const { code, data } = await previewRechargeReward({});
  // const { code, data } = {
  //   code: 0,
  //   data: {
  //     canFirstRecharge: true,
  //     firstRechargeMaxRate: 2345,
  //     canRepeatRecharge: true,
  //     repeatRechargeMaxRate: 2345,
  //   },
  // };
  if (code === 0) {
    let curCount = 1;
    let firstTime = 0;
    let repeatTime = 0;
    let luckyTime = 0;
    if (time >= firstTimeStampe && time < lastTimeStampe && count < 1) {
      curCount = count + 1;
      firstTime = chargeLuckyGuide.firstTime || 0;
      repeatTime = chargeLuckyGuide.repeatTime || 0;
      luckyTime = chargeLuckyGuide.luckyTime || 0;
    }
    const chargeLuckyGuide1 = {
      time: new Date().getTime(),
      count: curCount,
      firstTime: firstTime,
      repeatTime: repeatTime,
      luckyTime: luckyTime,
    };
    const getAppConfig = vm.$store.getters?.getPacketConfig?.appConfig || {};
    const isNewWithdrawMode =
      getAppConfig.withdrawMode === "WITHDRAW_MODE_FREE_GOLD";
    if (data.canBankruptGuide && type === "Bankruptcy") {
      // 破产引导
      if (data.bankruptConfig && data.bankruptConfig.length) {
        // isTipGame = true;
        const expireTime = Number(data.bankruptExpireAt || 0);
        const obj = data.bankruptConfig.find(
          (it) => it.guideType === "BANKRUPT_GUIDE_TYPE_RECHARGE_GIFT"
        );
        const list = data.bankruptConfig.filter(
          (it) => it.guideType !== "BANKRUPT_GUIDE_TYPE_RECHARGE_GIFT"
        );
        // 如果有充值礼包，弹礼包
        if (obj && obj.rechargeGiftId && obj.rechargeGiftId !== "0") {
          isTipGame = true;
          vm.$isPopShow({
            show: true,
            views: "chargeEnvelope",
            fullscreen: false,
            data: {
              sid: obj.rechargeGiftId,
              SubGiftpack: "Bankruptcy",
              title: "",
              width: "360px",

              bankruptData: {
                expireTime,
                isLocal: true,
                items: list,
                bankruptGuideType: data.bankruptGuideType || 0,
              },
              chargeLuckyGuide: chargeLuckyGuide1,
            },
          });
        } else {
          // 如果没有充值礼包，弹幸运补贴
          if (list.length) {
            isTipGame = true;
            localStorage.setItem(
              "chargeLuckyGuide",
              JSON.stringify(chargeLuckyGuide1)
            );
            // 调用破产引导弹窗
            vm.$Bus.$emit("luckySubsidyGuide", {
              expireTime,
              isLocal: true,
              items: list,
              bankruptGuideType: data.bankruptGuideType || 0,
            });
          }
        }
      }
    } else if (
      data.canFirstRecharge &&
      !isNewWithdrawMode &&
      type === "Recharge"
    ) {
      isTipGame = true;
      localStorage.setItem(
        "chargeLuckyGuide",
        JSON.stringify(chargeLuckyGuide1)
      );
      // 首充引导
      vm.$Bus.$emit("chargeGuide", {
        type: 1,
        maxRate: data.firstRechargeMaxRate || 0,
        position,
      });
    } else if (
      data.canRepeatRecharge &&
      !isNewWithdrawMode &&
      type === "Recharge"
    ) {
      isTipGame = true;
      localStorage.setItem(
        "chargeLuckyGuide",
        JSON.stringify(chargeLuckyGuide1)
      );
      // 复充引导
      vm.$Bus.$emit("chargeGuide", {
        type: 2,
        maxRate: data.repeatRechargeMaxRate || 0,
        position,
      });
    }
  }
  // }
  if (!isTipGame) {
    vm.$popConfig.winConfigNext();
  }
}
// 从游戏返回首页进行 破产引导、首充、复充 > 首提弹窗提示 > 定时红包引导 > 奖励提示
// 从其他页面返回首页进行 破产引导、首充、复充 > 定时红包引导
export async function getPreviewRechargeReward(isExitGame) {
  // isExitGame 是否是从游戏退出
  if (!vm.$store.getters.login) return;
  // 是否异步弹出充值转盘
  showChargeWheel();
  let isTipGame = false;
  // 引导每日最多触发5次,改成1次
  const chargeLuckyGuide = JSON.parse(
    localStorage.getItem("chargeLuckyGuide") || "{}"
  );
  const time = Number(chargeLuckyGuide.time || 0);
  const count = Number(chargeLuckyGuide.count || 0);
  const { firstTimeStampe, lastTimeStampe } = getDateLastTimeStampe();
  // console.log(time - firstTimeStampe, time - lastTimeStampe);
  if (
    time < firstTimeStampe ||
    time >= lastTimeStampe ||
    (time >= firstTimeStampe && time < lastTimeStampe && count < 1)
  ) {
    const { code, data } = await previewRechargeReward({});
    // const { code, data } = {
    //   code: 0,
    //   data: {
    //     canFirstRecharge: true,
    //     firstRechargeMaxRate: 2345,
    //     canRepeatRecharge: true,
    //     repeatRechargeMaxRate: 2345,
    //   },
    // };
    if (code === 0) {
      let curCount = 1;
      let firstTime = 0;
      let repeatTime = 0;
      let luckyTime = 0;
      if (time >= firstTimeStampe && time < lastTimeStampe && count < 1) {
        curCount = count + 1;
        firstTime = chargeLuckyGuide.firstTime || 0;
        repeatTime = chargeLuckyGuide.repeatTime || 0;
        luckyTime = chargeLuckyGuide.luckyTime || 0;
      }
      const chargeLuckyGuide1 = {
        time: new Date().getTime(),
        count: curCount,
        firstTime: firstTime,
        repeatTime: repeatTime,
        luckyTime: luckyTime,
      };
      const getAppConfig = vm.$store.getters?.getPacketConfig?.appConfig || {};
      const isNewWithdrawMode =
        getAppConfig.withdrawMode === "WITHDRAW_MODE_FREE_GOLD";
      if (data.canBankruptGuide) {
        // 破产引导
        if (data.bankruptConfig && data.bankruptConfig.length) {
          // isTipGame = true;
          const expireTime = Number(data.bankruptExpireAt || 0);
          // const luckyExpireTime = {
          //   expireTime,
          // };
          // window.localStorage.setItem(
          //   "luckyExpireTime",
          //   JSON.stringify(luckyExpireTime)
          // );
          // localStorage.setItem(
          //   "chargeLuckyGuide",
          //   JSON.stringify(chargeLuckyGuide1)
          // );
          const obj = data.bankruptConfig.find(
            (it) => it.guideType === "BANKRUPT_GUIDE_TYPE_RECHARGE_GIFT"
          );
          const list = data.bankruptConfig.filter(
            (it) => it.guideType !== "BANKRUPT_GUIDE_TYPE_RECHARGE_GIFT"
          );
          // 如果有充值礼包，弹礼包
          if (obj && obj.rechargeGiftId && obj.rechargeGiftId !== "0") {
            isTipGame = true;
            vm.$isPopShow({
              show: true,
              views: "chargeEnvelope",
              fullscreen: false,
              data: {
                sid: obj.rechargeGiftId,
                SubGiftpack: "Bankruptcy",
                title: "",
                width: "360px",

                bankruptData: {
                  expireTime,
                  isLocal: true,
                  items: list,
                  bankruptGuideType: data.bankruptGuideType || 0,
                },
                chargeLuckyGuide: chargeLuckyGuide1,
              },
            });
          } else {
            // 如果没有充值礼包，弹幸运补贴
            if (list.length) {
              isTipGame = true;
              localStorage.setItem(
                "chargeLuckyGuide",
                JSON.stringify(chargeLuckyGuide1)
              );
              // 调用破产引导弹窗
              vm.$Bus.$emit("luckySubsidyGuide", {
                expireTime,
                isLocal: true,
                items: list,
                bankruptGuideType: data.bankruptGuideType || 0,
              });
            }
          }
        }
      } else if (data.canFirstRecharge && !isNewWithdrawMode) {
        isTipGame = true;
        localStorage.setItem(
          "chargeLuckyGuide",
          JSON.stringify(chargeLuckyGuide1)
        );
        // 首充引导
        vm.$Bus.$emit("chargeGuide", {
          type: 1,
          maxRate: data.firstRechargeMaxRate || 0,
        });
      } else if (data.canRepeatRecharge && !isNewWithdrawMode) {
        isTipGame = true;
        localStorage.setItem(
          "chargeLuckyGuide",
          JSON.stringify(chargeLuckyGuide1)
        );
        // 复充引导
        vm.$Bus.$emit("chargeGuide", {
          type: 2,
          maxRate: data.repeatRechargeMaxRate || 0,
        });
      }
    }
  }
  // hotfix-0815 注释掉首提弹窗
  // if (!isTipGame && isExitGame) {
  //   // v2.12.2 首提提示弹窗优先级在破产引导之后，在弹窗奖励提示之前
  //   showFirstWithdrawDialog("Return");
  //   // // 调用是否弹窗奖励提示接口
  //   // getGameRewardList("game");
  // } else
  if (!isTipGame) {
    // 首页，但不是从游戏退出的
    // console.log(1111, "showRedeemTimeDialog");
    showRedeemTimeDialog(isExitGame ? "Return" : "");
  }
}

// 首提弹窗提示
export async function showFirstWithdrawDialog(type = "Return", position = "") {
  if (!vm.$store.getters.login) {
    vm.$popConfig.winConfigNext();
    return true;
  }
  const userInfo = vm.$store.getters.user || {};
  let isTipGame = false;
  if (!userInfo.isWithdraw) {
    isTipGame = await gameFirstWithdrawDialog(userInfo, type, position);
  }
  if (!isTipGame) {
    vm.$popConfig.winConfigNext();
  }
  return !isTipGame;
}

export async function gameFirstWithdrawDialog(userInfo, type, position) {
  let isTipGame = false;
  const appConfig = vm.$store.getters.getPacketConfig?.appConfig || {};
  const { code, data } = await getUserFirstWithdrawInfo({
    coinCode: userInfo.coinCode,
  });
  // const { code, data } = {
  //   code: 0,
  //   data: {
  //     coinCode: "BRL",
  //     totalAmount: 50,
  //     minWithdrawAmount: 10,
  //     maxWithdrawAmount: 20,
  //     withdrawWalletAmount: 5,
  //     needCoding: 10,
  //     currentCoding: 5,
  //   },
  // };
  if (code === 0) {
    const obj = data || {};
    // 用户总余额
    const totalAmount = Number(obj.totalAmount || 0);
    // 最小可提金额
    const minWithdrawAmount = Number(obj.minWithdrawAmount || 0);
    // 最大可提金额
    const maxWithdrawAmount = Number(obj.maxWithdrawAmount || 0);
    // 可提钱包余额
    const withdrawWalletAmount = Number(obj.withdrawWalletAmount || 0);
    // 要求打码
    const needCoding = Number(obj.needCoding || 0);
    // 实际打码
    const currentCoding = Number(obj.currentCoding || 0);

    let withdrawType = 1;
    let percentage = 0;
    if (appConfig.withdrawMode === "WITHDRAW_MODE_IGNORE") {
      // 首提引导不区分真实账户模式下，打码要求大于0时，应弹出提现进度弹窗
      if (
        needCoding === 0 &&
        withdrawWalletAmount >= minWithdrawAmount &&
        totalAmount > 0 &&
        minWithdrawAmount > 0
      ) {
        isTipGame = true;
        // 提现引导弹窗
        withdrawType = 2;
        percentage = 100;
      } else if (needCoding > 0) {
        isTipGame = true;
        // 提现引导弹窗
        percentage = currentCoding / needCoding;
      } else {
        isTipGame = false;
        return isTipGame;
      }
    } else {
      // 用户总余额>0   用户总余额大于最小可提金额
      if (
        totalAmount > 0 &&
        minWithdrawAmount > 0 &&
        totalAmount > minWithdrawAmount
      ) {
        isTipGame = true;
        if (withdrawWalletAmount < minWithdrawAmount) {
          // 提现进度弹窗
          if (needCoding) {
            percentage = currentCoding / needCoding;
          } else {
            percentage = 100;
            isTipGame = false;
            return isTipGame;
          }
        } else {
          // 提现引导弹窗
          withdrawType = 2;
          percentage = 100;
        }
      } else {
        isTipGame = false;
        return isTipGame;
      }
    }

    // 首提引导
    vm.$Bus.$emit("firstWithdrawGuide", {
      type,
      withdrawType,
      percentage,
      coinCode: obj.coinCode,
      totalAmount,
      minWithdrawAmount,
      maxWithdrawAmount,
      withdrawWalletAmount,
      needCoding,
      currentCoding,
      position,
    });
  }
  return isTipGame;
}
// 跳转首提
export async function FirstWithdrawalProgress() {
  const userInfo = vm.$store.getters.user || {};
  const appConfig = vm.$store.getters.getPacketConfig?.appConfig || {};

  // console.log(appConfig, "siteConfig");
  const { code, data } = await getUserFirstWithdrawInfo({
    coinCode: userInfo.coinCode,
  });
  // const { code, data } = {
  //   code: 0,
  //   data: {
  //     coinCode: "BRL",
  //     totalAmount: 50,
  //     minWithdrawAmount: 10,
  //     maxWithdrawAmount: 20,
  //     withdrawWalletAmount: 5,
  //     needCoding: 10,
  //     currentCoding: 5,
  //   },
  // };
  if (code === 0) {
    const obj = data || {};
    // const obj = { ...data, minWithdrawAmount: 100 } || {};
    // 用户总余额
    const totalAmount = Number(obj.totalAmount || 0);
    // 最小可提金额
    const minWithdrawAmount = Number(obj.minWithdrawAmount || 0);
    // 最大可提金额
    const maxWithdrawAmount = Number(obj.maxWithdrawAmount || 0);
    // 可提钱包余额
    const withdrawWalletAmount = Number(obj.withdrawWalletAmount || 0);
    // 要求打码
    const needCoding = Number(obj.needCoding || 0);
    // 实际打码
    const currentCoding = Number(obj.currentCoding || 0);
    // 用户总余额>0   用户总余额大于最小可提金额
    let withdrawType = 1;
    let percentage = 0;
    if (appConfig.withdrawMode === "WITHDRAW_MODE_IGNORE") {
      // 首提引导不区分真实账户模式下，打码要求大于0时，应弹出提现进度弹窗
      if (
        needCoding === 0 &&
        withdrawWalletAmount >= minWithdrawAmount &&
        totalAmount > 0 &&
        minWithdrawAmount > 0
      ) {
        // 提现引导弹窗
        withdrawType = 2;
        percentage = 100;
      } else if (needCoding > 0) {
        // 提现引导弹窗
        percentage = currentCoding / needCoding;
      } else {
        return;
      }
    } else {
      // 用户总余额>0   用户总余额大于最小可提金额
      if (
        totalAmount > 0 &&
        minWithdrawAmount > 0 &&
        totalAmount > minWithdrawAmount
      ) {
        if (withdrawWalletAmount < minWithdrawAmount) {
          // 提现进度弹窗
          if (needCoding) {
            percentage = currentCoding / needCoding;
          } else {
            percentage = 100;

            return;
          }
        } else {
          // 提现引导弹窗
          withdrawType = 2;
          percentage = 100;
        }
      } else {
        return;
      }
    }
    // 首提引导
    vm.$Bus.$emit("firstWithdrawGuide", {
      type: "Function",
      withdrawType,
      percentage,
      coinCode: obj.coinCode,
      totalAmount,
      minWithdrawAmount,
      maxWithdrawAmount,
      withdrawWalletAmount,
      needCoding,
      currentCoding,
    });
  }
}

// 定时红包引导
export async function showRedeemTimeDialog(position = "") {
  if (!vm.$store.getters.login) {
    vm.$popConfig.winConfigNext();
    return true;
  }
  const activityTypes =
    vm.$store.getters.getAllEnableFeature?.activityTypes || [];
  const hasActivityType = activityTypes.includes(
    "ActivityTypeTimingRedEnvelope"
  );
  let isTipGame = false;
  const userInfo = vm.$store.getters.user || {};
  console.log("userInfo", userInfo, "hasActivityType", hasActivityType);
  // 定时红包活动 未充值
  if (!userInfo.isRecharge && hasActivityType) {
    // 之前没提现过
    // 取存储数据
    const redeemTimeGuideInfo = JSON.parse(
      localStorage.getItem("redeemTimeGuideInfo") || "{}"
    );
    // const redeemTimeGuideInfo = {
    //   DINGSHI: obj.nextTime,
    //   timesMinutes: obj.timesMinutes,
    //   nextDay: obj.nextDay,
    //   lastTimeStampe: getAppDateLastTimeStampe(),
    // };
    const dingshi = redeemTimeGuideInfo.DINGSHI || {};
    // const timesMinutes = redeemTimeGuideInfo.timesMinutes || [];
    const lastTimeStampe = redeemTimeGuideInfo.lastTimeStampe || 0;
    const todayLastTimeStampe = getAppDateLastTimeStampe();
    const curTimestamp = getAnyZoneTimeStamp();
    console.log("curTimestamp", curTimestamp, "lastTimeStampe", lastTimeStampe);
    let isRequire = true;
    if (dingshi.totalMinutes) {
      if (redeemTimeGuideInfo.nextDay) {
        if (todayLastTimeStampe <= lastTimeStampe) {
          isRequire = false;
        } else {
          // 如果是第二天，重新计算当前时间
          const now = new Date(getAnyZoneTimeStamp());
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          const currentTotalMinutes =
            Number(currentHour) * 60 + Number(currentMinute);
          if (currentTotalMinutes <= dingshi.totalMinutes) {
            isRequire = false;
          }
        }
        // // 过滤出大于当前时分的时间项
        // const futureTimes = timesMinutes.filter(
        //   (item) => item.totalMinutes >= currentTotalMinutes
        // );
        // if (futureTimes.length) {
        // }
      } else if (!redeemTimeGuideInfo.nextDay) {
        if (todayLastTimeStampe <= lastTimeStampe) {
          const now = new Date(getAnyZoneTimeStamp());
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          const currentTotalMinutes =
            Number(currentHour) * 60 + Number(currentMinute);
          if (currentTotalMinutes <= dingshi.totalMinutes) {
            isRequire = false;
          }
        }
      }
    }
    if (isRequire) {
      localStorage.removeItem("redeemTimeGuideInfo");
      const { code, data } = await redEnvelopeTimingGet({});
      if (code === 0) {
        console.log("data", data);
        const obj = data || {};
        // 用户总余额
        const totalAmount = Number(obj.totalAmount || 0);
        const maxReceiveAmount = Number(obj.maxReceiveAmount || 0);
        isTipGame = true;
        vm.$Bus.$emit("redeemTimeGuide", {
          timingNum: obj.timingNum || {},
          timing: obj.timing || [],
          totalAmount,
          maxReceiveAmount,
          durationMinute: obj.durationMinute,
          position,
        });
      }
    }
  }
  if (!isTipGame) {
    vm.$popConfig.winConfigNext();
  }
  // if (!isTipGame && type === "Return") {
  //   // 调用是否弹窗奖励提示接口
  //   getGameRewardList("game");
  // }
}

// 退出游戏时奖励提示  ===== 在奖励也有提示
export async function getGameRewardList(curPath) {
  if (!vm.$store.getters.login) return;
  const getAppConfig = vm.$store.getters?.getPacketConfig?.appConfig || {};
  const isNewWithdrawMode =
    getAppConfig.withdrawMode === "WITHDRAW_MODE_FREE_GOLD";
  if (isNewWithdrawMode) return;
  try {
    const { code, data } = await getActivityRewardGuide({});
    if (code === 0) {
      const dataObj = data || {};
      const keys = Object.keys(dataObj);
      const arr = [];
      keys.map((key) => {
        if (dataObj[key] && key !== "sum") {
          const item = dataObj[key];
          item.type = typeMap[key];
          item.key = key;
          arr.push(item);
        }
      });
      arr.sort((a, b) => {
        const aSort = Number(a.sort) || 0;
        const bSort = Number(b.sort) || 0;
        return aSort - bSort;
      });
      let todayTip = false;
      let tomstr = "";
      let i = 1;
      const typeArr = [];
      const { firstTimeStampe, lastTimeStampe } = getDateLastTimeStampe();
      const rewardTip2 = JSON.parse(localStorage.getItem("rewardTip2") || "{}");
      const tip2time = Number(rewardTip2.time || 0);
      const showList = rewardTip2.showList || [];
      arr.forEach((item) => {
        if (item.status === 2 && item.key !== "redRedeemCodeReward") {
          todayTip = true;
        }
        if (
          item.hasRewardTomorrow === "STATUS_BOOL_TRUE" &&
          tomorrowType.includes(item.key)
        ) {
          let activityName = "";
          switch (item.key) {
            case "rebate":
              activityName = vm.$t("Datalang.home_Cash_back");
              break;
            case "tertiaryReward":
              activityName = vm.$t("Datalang.home_Three-level_distribution");
              break;
            case "unlimitedReward":
              activityName = vm.$t("Datalang.home_National_promotion");
              break;
            case "normalPrecious":
              activityName = vm.$t("Datalang.home_Treasure_box");
              break;

            default:
              break;
          }
          typeArr.push(item.key);
          tomstr = tomstr + `<div>${i}. ${activityName}</div>`;
          i++;
        }
      });

      const rewardTip1 = Number(localStorage.getItem("rewardTip1") || 0);
      let canTip1 = false;
      if (
        !rewardTip1 ||
        rewardTip1 < firstTimeStampe ||
        rewardTip1 >= lastTimeStampe
      ) {
        canTip1 = true;
      }
      let canTip2 = false;
      if (
        showList.length &&
        tip2time &&
        tip2time >= firstTimeStampe &&
        tip2time < lastTimeStampe
      ) {
        // 判断是否有新的活动完成
        if (typeArr.length > showList.length) {
          canTip2 = true;
        }
      } else {
        canTip2 = true;
      }
      let type = 0;
      if (todayTip && canTip1 && curPath === "game") {
        type = 1;
      } else if (canTip2 && typeArr.length) {
        type = 2;
      }
      // console.log("======arr=========", arr);
      if (type) {
        let str = "";
        let tip = vm.$t("Datalang.newly_bonus");
        let btntext = "";
        // let customClass = "";
        const nowtime = new Date().getTime();
        if (type === 1) {
          str = vm.$t("Datalang.home_There_are");
          btntext = vm.$t("Datalang.home_View");
          vm.$eventPost("today_reward_tips_pop");
          // localStorage.setItem("rewardTip1", nowtime);
        } else {
          //
          vm.$eventPost("tomorrow_reward_tips_pop", { location: "home" });
          str =
            tomstr +
            `<div style="margin-top:10px">${vm.$t(
              "Datalang.home_The_above"
            )}</div>`;
          // tip = vm.$t("Datalang.home_Tomorrows_reward");
          tip = vm.$t("Datalang.Recharge_TIP_tip");
          btntext = vm.$t("Datalang.Withdrawl_TIP_getit");
          // customClass = "msg-left";
          localStorage.setItem(
            "rewardTip2",
            JSON.stringify({ time: nowtime, showList: typeArr })
          );
        }
        vm.$Bus.$emit("gameRewardTip", {
          show: true,
          type,
          curPath,
          titletext: str,
          btntext,
          tip,
        });
        // vm.$confirm(str, tip, {
        //   confirmButtonText: btntext,
        //   showCancelButton: false,
        //   closeOnClickModal: false,
        //   dangerouslyUseHTMLString: true,
        //   customClass,
        // })
        //   .then(async () => {
        //     vm.$eventPost("today_reward_view_click");
        //     // 跳奖励页面充值
        //     if (curPath === "game" && type === 1) {
        //       const path = vm.getIsMobile ? "/hEvents" : "/events";
        //       vm.$router.push({
        //         path: path,
        //         query: {
        //           tab: 1,
        //           t: Date.now(),
        //         },
        //       });
        //     }
        //   })
        //   .catch(() => {
        //     // 今日奖励只提示一次
        //     if (type === 1) {
        //       localStorage.setItem("rewardTip1", nowtime);
        //     }
        //   });
      }
    }
  } finally {
  }
}
// 是否弹出充值转盘
export async function showChargeWheel(position) {
  if (!vm.$store.getters.login) {
    vm.$popConfig.winConfigNext();
    return;
  }
  let isTipGame = false;
  // 弹出条件：0.活动开启了 1.返回到首页  2.当天未充值 3.之前未弹出或超过弹出时间间隔 4.返回首页30s，并且在首页 5.没有任何弹窗
  const activityTypes =
    vm.$store.getters.getAllEnableFeature?.activityTypes || [];
  const hasActivityType = activityTypes.includes(
    "ActivityTypeRechargeTurntable"
  );
  if (!hasActivityType) {
    vm.$popConfig.winConfigNext();
    return;
  }
  const userInfo = vm.$store.getters.user || {};
  const lastChargeTime = Number(userInfo.latestRechargeTime || 0);
  const lastTimeStampe = getAppDateLastTimeStampe();
  const firstTimeStampe = (lastTimeStampe - 86400000) / 1000;
  // 2.当天未充值
  if (lastChargeTime === 0 || lastChargeTime < firstTimeStampe) {
    // const chargeWheelConfig = JSON.parse(
    //   localStorage.getItem("chargeWheelConfig") || "{}"
    // );
    // const nextShowTime = Number(chargeWheelConfig.nextShowTime || 0);
    // const curTimeStamp = getAnyZoneTimeStamp();
    // console.log(nextShowTime, curTimeStamp + 30000 - nextShowTime);
    // 3.之前未弹出或超过弹出时间间隔
    // if (nextShowTime === 0 || curTimeStamp + 30000 >= nextShowTime) {
    // setTimeout(async () => {
    // 4.返回首页30s，并且在首页
    // if (vm.$route.path === "/home" || vm.$route.path === "/") {
    // 5.没有任何弹窗
    // const dialogs = document.querySelectorAll(
    //   '.el-dialog__wrapper:not([style*="display: none"])'
    // );
    // if (!dialogs.length) {
    const { code, data } = await getRechargeTurntableInfo({});
    if (code === 0 && data.canDraw) {
      isTipGame = true;
      console.log("data", data);
      vm.$isPopShow({
        show: true,
        views: "rechargeTurntable",
        data: {
          backBtn: false,
          title: "",
          SubTurntable: "Notecharged",
          chargeWheelData: {
            ...data,
          },
          position,
        },
      });
    }
    // }
    // }
    // }, 30000);
    // }
  }
  if (!isTipGame) {
    vm.$popConfig.winConfigNext();
  }
}

// 游戏限制拉配置
export async function getShowGameLimitDialog(gameGroupSid, limitType = "") {
  // limitType现在类型   balanceLimit:余额限制  默认:充值金额现在
  const { code, data } = await getGameLimit({ gameGroupSid });
  if (code === 0) {
    if (limitType === "balanceLimit") {
      // 余额限制
      if (data.realWalletPopupContent === "2") {
        // 充值礼包
        jumpRechargeGift({
          type: "JUMP_TYPE_RECHARGE_GIFT",
          taskJump: data.realWalletRechargeGiftSid,
        });
        if (
          data.realWalletRetainGiftSid &&
          data.realWalletRetainGiftSid !== "0"
        ) {
          // 充值礼包挽留 存储vux
          vm.$store.commit("setRetainGiftSid", data.realWalletRetainGiftSid);
        }
      } else {
        const language = data.language || {};
        language.content = data.language?.realWalletContent;
        language.btnText = data.language?.realWalletBtnText;
        vm.$Bus.$emit("gameLimit", {
          popupContent: data.realWalletPopupContent,
          jump: data.realWalletJump || {},
          language: { ...language },
          rechargeGiftSid: data.realWalletRechargeGiftSid,
        });
      }
    } else {
      if (data.popupContent === "2") {
        // 充值礼包
        jumpRechargeGift({
          type: "JUMP_TYPE_RECHARGE_GIFT",
          taskJump: data.rechargeGiftSid,
        });
        if (data.retainGiftSid && data.retainGiftSid !== "0") {
          // 充值礼包挽留 存储vux
          vm.$store.commit("setRetainGiftSid", data.retainGiftSid);
        }
      } else {
        vm.$Bus.$emit("gameLimit", {
          popupContent: data.popupContent,
          jump: data.jump || {},
          language: data.language || {},
          rechargeGiftSid: data.rechargeGiftSid,
        });
      }
    }
  }
}
export function px2rem(px) {
  const rootFontSize = 10; // 与 postcss-pxtorem 配置的 rootValue 一致
  return `${px / rootFontSize}rem`;
}

export function isInTelegramWebApp() {
  try {
    // 检查是否存在 WebApp 对象
    if (!window.Telegram?.WebApp) {
      return false;
    }
    // 检查平台信息
    const platform = window.Telegram.WebApp.platform;
    // 检查初始化数据
    const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
    // 大于8.0 才支持全屏
    const version = window.Telegram.WebApp.version;

    return Boolean(platform && initDataUnsafe && version >= "8.0");
  } catch (e) {
    return false;
  }
}

// 是否TG
export function isTg() {
  const initQuery =
    JSON.parse(JSON.stringify(getLocalStorage("initQuery"))) || {};
  return initQuery.ft === "tg";
}

// 判断是否在TG Mobile APP 下全屏模式下运行
export function isInTelegramMobileApp() {
  try {
    // 检查是否存在 WebApp 对象
    if (!window.Telegram?.WebApp) {
      return false;
    }
    // 检查平台信息
    const platform = window.Telegram.WebApp.platform;
    // 检查初始化数据
    const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
    return Boolean(
      platform && initDataUnsafe && ["android", "ios"].includes(platform)
    );
  } catch (e) {
    return false;
  }
}

export function isTagApp() {
  try {
    // 检查是否存在 WebApp 对象
    if (!window.Telegram?.WebApp) {
      return false;
    }
    // 检查平台信息
    const platform = window.Telegram.WebApp.platform;
    // 检查初始化数据
    const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
    return Boolean(platform && initDataUnsafe);
  } catch (e) {
    return false;
  }
}

// 获取主站域名
export function getMainDomain(url) {
  // 移除协议（http, https, ftp）
  url = url.replace(/^https?:\/\//i, "");
  // 移除端口号
  url = url.replace(/:\d+$/, "");
  // 移除www
  url = url.replace(/^www\./, "");
  // 匹配主域
  const matches = url.match(/^([^.]+\.[^.]+?\.[^.]+?)$/);
  return matches ? matches[1] : url;
}

// tg分享地址
export const tgShareUrl = async (noCode = false) => {
  if (isTg()) {
    // tg
    const initQuery =
      JSON.parse(JSON.stringify(getLocalStorage("initQuery"))) || {};
    const { data, code } = await getPacketRobotBySid({
      sid: initQuery.packet_robot_sid || "0",
    });
    if (code === 0 && data?.tgShareUrl) {
      const inviteCode = vm.$store.getters.user?.inviteCode;
      return noCode === true
        ? data?.tgShareUrl
        : data?.tgShareUrl + "?start=" + inviteCode;
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export function hasElDialogShow() {
  let flag = false;
  try {
    // 获取所有弹窗
    const dialogs = document.querySelectorAll(".el-dialog__wrapper");
    dialogs.forEach((dialog) => {
      const vm = dialog.__vue__;
      if (vm) {
        const parentVm = vm.$parent;
        if (parentVm && parentVm.visible) {
          flag = true;
        }
      }
    });
  } catch (error) {
    console.error("关闭并销毁弹窗时发生错误:", error);
  }
  return flag;
}

export function closeAllDialogs() {
  try {
    // 获取所有弹窗
    const dialogs = document.querySelectorAll(".el-dialog__wrapper");

    dialogs.forEach((dialog) => {
      const vm = dialog.__vue__;
      if (vm) {
        // 1. 先关闭弹窗
        // vm.$emit("update:visible", false);
        // 2. 获取父组件实例
        const parentVm = vm.$parent;
        if (parentVm && parentVm.visible) {
          // 3. 设置 visible 为 false
          if (parentVm.show) {
            parentVm.show = false;
          }
          if (parentVm.visible) {
            parentVm.visible = false;
          }

          // 4. 等待动画结束后销毁组件
          setTimeout(() => {
            // 销毁组件
            // parentVm.$destroy();
            // 移除DOM元素
            // if (parentVm.$el && parentVm.$el.parentNode) {
            //   parentVm.$el.parentNode.removeChild(parentVm.$el);
            // }
          }, 300); // 300ms是el-dialog的默认动画时长
        }
      }

      // 移除DOM元素
      // if (dialog.parentNode) {
      //     dialog.parentNode.removeChild(dialog);
      // }
    });
  } catch (error) {
    console.error("关闭并销毁弹窗时发生错误:", error);
  }
}

export async function setLangFromUser(data) {
  // 判断用户语言以及当前语言
  // const localLanguage = getLocalStorage("lang")?.lang;
  const languageArr = vm.$store.getters.getPacketConfig?.packetInfo?.baseInfo
    ?.languages || ["en"];
  const urlParams = new URLSearchParams(window.location.search);
  const urlLanguage = urlParams?.get?.("language");
  if (
    data.language &&
    languageArr?.includes(data.language) &&
    data.language !== vm.$store.getters.getLang &&
    (!urlLanguage || !languageArr?.includes(urlLanguage))
  ) {
    setLocale(data.language);
    try {
      // await adjustTrackEvent({ eventToken: "login" });
      setTimeout(async () => {
        window.location.reload();
      }, 100);
    } catch (error) {
      setTimeout(async () => {
        window.location.reload();
      }, 100);
    }
  } else if (
    urlLanguage &&
    languageArr?.includes(urlLanguage) &&
    data.language !== urlLanguage
  ) {
    try {
      await updateUserLanguage({ language: urlLanguage });
    } catch (error) {}
  }
}
// 签到活动状态
export function SignEventStatus() {
  const SignEventStatus =
    vm.$store.getters.getPacketConfig?.packetInfo?.baseInfo
      ?.specificMultilingualDisplay === "STATUS_BOOL_TRUE";
  return SignEventStatus;
  // specificMultilingualDisplay
  // vm.$store.getters.getPacketConfig?.packetInfo?.baseInfo?.packLanguages
}

// 根据域名判断是否显示宝箱详情
export function isShowBoxDetail() {
  // 是否展示宝箱详情
  const isOpen =
    vm.$store?.getters?.getPacketConfig?.packetInfo?.baseInfo
      ?.preciousDisplay === "STATUS_BOOL_TRUE";
  return isOpen;
  // const urlsText = [
  //   "papp-pc-lobby-1701.yj-sit.xyz",
  //   "papp-pc-lobby-1701.yj-uat.xyz",
  //   "papp-pc-lobby-1707.yj-sit.xyz",
  //   "papp-pc-lobby-1707.yj-uat.xyz",
  // ]; // 给测试用的地址
  // const urls = ["7.bet", "ng7.bet", "ng7bet.com"]; // 正式地址
  // const urlsAll = [...urlsText, ...urls];
  // const curHost = getMainDomain(window.location.host); // 当前域名  window.location.host
  // return urlsAll.includes(curHost);
}

// 提现虚拟币协议是否限制
export function isVirtualLimit(coinCode, protocol, isGetProtocols) {
  let isShowLimit = false;
  const withdrawProtocol = vm.$store?.getters?.user?.withdrawProtocols || [];
  const obj = {};
  withdrawProtocol.map((v) => {
    const delimiter = " ";
    const index = v.indexOf(delimiter);
    const firPart = v.substring(0, index);
    const sedPart = v.substring(index + 1);
    obj[firPart] = obj[firPart] ? [...obj[firPart], sedPart] : [sedPart];
  });
  const coinProtocols = obj[coinCode] || [];
  if (isGetProtocols) {
    return coinProtocols.join("、");
  }
  if (coinProtocols.length > 0 && !coinProtocols.includes(protocol)) {
    isShowLimit = true;
  }
  return isShowLimit;
}

// 改变富文本超链接的跳转方式
export function changeTarget(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const links = doc.querySelectorAll("a");
  const host = window.location.host;

  links.forEach(function (link) {
    if (link.href.includes(host)) {
      link.target = "_self";
    }
  });
  const serializer = new XMLSerializer();
  const newXmlString = serializer.serializeToString(doc); // 获取更新后的XML字符串表示
  return newXmlString;
}

// AF上报漏充值
let afLoading = false;
export async function afPostRecharge(adsConfig) {
  // console.log(
  //   "==================afPostRecharge====================",
  //   adsConfig
  // );
  const androidview = localStorage.getItem("AFAndroidview");
  // 携带了androidview参数，并且配置了af上报
  if (!androidview) return;
  if (!vm.$store.getters.login) return;
  const orderNumbers = getLocalStorage("windowOpenOrderNums") || [];
  const orders = [];
  const ordernums = [];
  orderNumbers.map((v) => {
    if (new Date().getTime() - v.time < 86400000) {
      orders.push(v);
      ordernums.push(v.orderNum);
    }
  });
  // console.log(
  //   "==================orderNumbers====================",
  //   orderNumbers,
  //   orders
  // );
  setLocalStorage("windowOpenOrderNums", orders);
  if (!ordernums.length) return;
  if (afLoading) return;
  afLoading = true;
  let adsEventConfig = [];
  if (adsConfig) {
    adsEventConfig = adsConfig;
  } else {
    adsEventConfig = vm.$store.state.adsEventConfig || [];
  }
  // 配置了af上报
  if (adsEventConfig.length) {
    const channelCodeObj = {};
    adsEventConfig.map((v) => {
      channelCodeObj[v.channelCode] = { ...v };
    });
    if (channelCodeObj["ADS_CODE_AF"]) {
      // const configJson = channelCodeObj['ADS_CODE_AF']?.config || ''
      // const config = configJson ? JSON.parse(configJson) : {}
      const funConfigJson = channelCodeObj["ADS_CODE_AF"]?.funcConfig || "";
      const funcConfig = funConfigJson ? JSON.parse(funConfigJson) : {};
      if (funcConfig["purchase"]) {
        const { code, data } = await rechargeOrderListByOrderNumbers({
          orderNumbers: ordernums,
        });
        if (code === 0 && data.list && data.list.length) {
          const list = data.list;
          // ORDER_STATUS_WAIT ORDER_STATUS_SUCCESS ORDER_STATUS_FAIL ORDER_STATUS_CANCEL ORDER_STATUS_TIMEOUT
          const arr = [];
          list.map((v) => {
            if (v.status === "ORDER_STATUS_WAIT") {
              const obj = orders.find((it) => it.orderNum === v.orderNumber);
              if (obj) {
                arr.push(obj);
              }
            }
            if (v.status === "ORDER_STATUS_SUCCESS") {
              // af充值成功
              afPostEvent({
                event: "purchase",
                amount: divideAccuracy(v.transMoney, v.accuracy),
                currency: v.coinCode,
                // productId: v.orderNumber,
              });
              afPostEvent({
                event: "complexRecharge",
                jsonobj: {
                  amount: divideAccuracy(v.transMoney, v.accuracy),
                  currency: v.coinCode,
                },
              });
            }
          });
          if (arr.length) {
            setLocalStorage("windowOpenOrderNums", arr);
          } else {
            setLocalStorage("windowOpenOrderNums", []);
          }
        }
      }
    }
  }
  afLoading = false;
}
export function setLocalOrderNumbers(orderNum) {
  const androidview = localStorage.getItem("AFAndroidview");
  if (!androidview) return;
  const orderNumbers = getLocalStorage("windowOpenOrderNums") || [];
  orderNumbers.push({ orderNum, time: new Date().getTime() });
  // console.log(
  //   "==================setLocalOrderNumbers====================",
  //   orderNumbers
  // );
  setLocalStorage("windowOpenOrderNums", orderNumbers);
}
export function removeLocalOrderNumbers(orderNum) {
  const androidview = localStorage.getItem("AFAndroidview");
  if (!androidview) return;
  const orderNumbers = getLocalStorage("windowOpenOrderNums") || [];
  if (orderNum && orderNumbers.length) {
    const arr = [];
    orderNumbers.forEach((v) => {
      if (v.orderNum !== orderNum) {
        arr.push(v);
      }
    });
    setLocalStorage("windowOpenOrderNums", arr);
  }
}

// 是否免打码模式
export function isFreeMode() {
  const withdrawMode =
    vm.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
  return withdrawMode === "WITHDRAW_MODE_FREE" || withdrawMode === 4;
}

export function getWithdrawMin(obj = {}, accuracy) {
  // 真实金额 可提现最小值
  const txt1 =
    obj.minFixed && Number(obj.minFixed) !== 0
      ? divideAccuracy(obj.minFixed, accuracy, "point") + "+"
      : "";
  const txt2 =
    obj.minRechargeMulti && Number(obj.minRechargeMulti) !== 0
      ? obj.minRechargeMulti +
        "*" +
        vm.$t("Datalang.newly_Deposit_amount2") +
        "+"
      : "";
  const txt3 =
    obj.minRewardMulti && Number(obj.minRewardMulti) !== 0
      ? obj.minRewardMulti + "*" + vm.$t("Datalang.newly_Bonus_amount3") + "+"
      : "";
  let str1 = txt1 + txt2 + txt3;
  str1 = str1 ? str1.slice(0, -1) : 0;
  return str1;
}

export function getWithdrawMax(obj = {}, accuracy) {
  // 真实金额 可提现最大值
  const txt4 =
    obj.maxFixed && Number(obj.maxFixed) !== 0
      ? divideAccuracy(obj.maxFixed, accuracy, "point") + "+"
      : "";
  const txt5 =
    obj.maxRechargeMulti && Number(obj.maxRechargeMulti) !== 0
      ? obj.maxRechargeMulti +
        "*" +
        vm.$t("Datalang.newly_Deposit_amount2") +
        "+"
      : "";
  const txt6 =
    obj.maxRewardMulti && Number(obj.maxRewardMulti) !== 0
      ? obj.maxRewardMulti + "*" + vm.$t("Datalang.newly_Bonus_amount3") + "+"
      : "";
  let str2 = txt4 + txt5 + txt6;
  str2 = str2 ? str2.slice(0, -1) : 0;
  return str2;
}

export function getAmountLimit(obj = {}, accuracy) {
  // 体验彩金 提现余额限制
  const txt1 =
    obj.balanceLimitFixed && Number(obj.balanceLimitFixed) !== 0
      ? divideAccuracy(obj.balanceLimitFixed, accuracy, "point") + "+"
      : "";
  const txt2 =
    obj.experienceMultiLimit && Number(obj.experienceMultiLimit) !== 0
      ? obj.experienceMultiLimit +
        "*" +
        vm.$t("Datalang.newly_Experience_amount") +
        "+"
      : "";
  let str1 = txt1 + txt2;
  str1 = str1 ? str1.slice(0, -1) : 0;
  return str1;
}

export function getCanWithdraw(obj = {}, accuracy) {
  // 体验彩金 可提现金额
  const txt3 =
    obj.withdrawAmountFixed && Number(obj.withdrawAmountFixed) !== 0
      ? divideAccuracy(obj.withdrawAmountFixed, accuracy, "point") + "+"
      : "";
  let str2 = txt3;
  str2 = str2 ? str2.slice(0, -1) : 0;
  return str2;
}

export function handleCoinCode(coinCode) {
  // 判断是否体验彩金货币  返回货币+是否体验彩金
  let curCoinCode = coinCode;
  let isExperienceWallet = false;
  if (coinCode.includes("experience")) {
    // 体验彩金
    const arr = coinCode.split(" ") || [];
    curCoinCode = arr[0] || "";
    isExperienceWallet = true;
  }
  return { curCoinCode, isExperienceWallet };
}

// 通用字符串替换*
export function hideStr(str, isEmail) {
  let newStr = "";
  if (isEmail) {
    // 邮箱
    const arr = str.split("@") || [];
    const first = arr[0] || "";
    const sed = arr[1] || "";
    let firstStr = "";
    if (first.length === 2) {
      firstStr = first.substring(0, 1) + "****";
    } else if (first.length === 3 || first.length === 4) {
      firstStr = first.substring(0, 2) + "****";
    } else if (first.length > 4) {
      firstStr =
        first.substring(0, 2) + "****" + first.substring(first.length - 2);
    } else {
      firstStr = "****";
    }
    newStr = firstStr + "@" + sed;
  } else {
    // 其他
    newStr = str.substring(0, 4) + "****" + str.substring(str.length - 4);
  }
  return newStr;
}

/**
 * Set cache data with expiration to localStorage
 * @param {string} key - Cache key
 * @param {Function} fetchFn - Function that returns Promise with data to cache
 * @param {number} expireTime - Cache expiration time in milliseconds (default 5 minutes)
 * @returns {Promise<any>} Cached data
 */
export async function setApiCache(key, fetchFn) {
  try {
    // Execute the fetch function
    const data = await fetchFn();

    // Store in localStorage
    localStorage.setItem(`cache_${key}`, JSON.stringify(data || ""));

    return data;
  } catch (error) {
    console.error(`Error setting cache for key ${key}:`, error);
    throw error;
  }
}

/**
 * Get cached data from localStorage and update if needed
 * @param {string} key - Cache key
 * @param {Function} updateFn - Function to update cache data
 * @param {number} expireTime - Cache expiration time in milliseconds (default 5 minutes)
 * @returns {Promise<any>} Cached or updated data
 */
export async function getApiCache(key, updateFn) {
  try {
    // Get cache from localStorage
    let cached = null;
    try {
      const cachedStr = localStorage.getItem(`cache_${key}`) || null;
      cached = cachedStr ? JSON.parse(cachedStr) : null;
    } catch (error) {}

    // Check if cache exists and is not expired
    if (cached) {
      // Execute update function in background
      updateFn &&
        updateFn()
          .then((newData) => {
            localStorage.setItem(`cache_${key}`, JSON.stringify(newData || ""));
          })
          .catch((error) => {
            console.error(`Error updating cache for key ${key}:`, error);
          });

      return cached;
    }

    // If no cache
    const newData = await updateFn();
    localStorage.setItem(`cache_${key}`, JSON.stringify(newData || ""));

    return newData;
  } catch (error) {
    console.error(`Error getting cache for key ${key}:`, error);
    throw error;
  }
}

// 载体类型
export const ContainerType = {
  // 未知
  unkown: 0, // 0; CONTAINER_TYPE_UNKOWN
  // 轻量包
  lightweight: 1, // 1; CONTAINER_TYPE_LIGHT_WEIGHT
  // 马甲包
  vestpackage: 2, // 2; CONTAINER_TYPE_VEST_PACKAGE
  // PWA
  pwa: 3, // 3; CONTAINER_TYPE_PWA
  // 快捷方式
  shortcut: 4, // 4; CONTAINER_TYPE_SHORTCUT
  // TG
  tg: 5, // 5; CONTAINER_TYPE_TG
  // 原生App
  native: 6, // 6; CONTAINER_TYPE_NATIVE
  // 浏览器
  normal: 7, // 7; CONTAINER_TYPE_BROWSER
};

// 1、lightweight、轻量包 2、pwa、3、shortcut、快捷方式  4、normal //自然
export function getContainerClientType() {
  let terminaltype = localStorage.getItem("terminaltype") || "normal";
  const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));
  if (isFromApp) {
    terminaltype = "vestpackage";
  }
  // const clientType = !vm.$store.getters?.getIsMobile ? 1 : 2;
  const clientType = !Store.getters?.getIsMobile ? 1 : 2;
  return {
    containerType: ContainerType[terminaltype],
    clientType,
  };
}

// 加密密码
export function encryptPassword(password) {
  return Encrypt(password);
}

// 解密密码
export function decryptPassword(password) {
  return Decrypt(password);
}

export async function loadGSAP() {
  const { gsap } = await import("gsap");
  // 现在可以安全使用 gsap
  return gsap;
}

/**
 * 飞金币动画
 * @param {Object} param0
 * @param {HTMLElement} param0.sourceEl 源元素
 * @param {HTMLElement} param0.targetEl 目标元素
 * @param {number} param0.coinCount 金币数量
 * @param {Function} param0.init 初始化回调
 * @param {Function} param0.onComplete 完成动画回调
 * @param {boolean} param0.showBirth 是否显示气泡动画
 * @returns
 */
export async function flyCoinWithAnime({
  sourceEl,
  targetEl,
  coinCount = 1,
  onInit,
  onComplete,
  showBirth = false,
}) {
  // 创建一个targetEl
  if (!targetEl) {
    targetEl = document.createElement("div");
    targetEl.id = "vStep";
    targetEl.style.position = "fixed";
    targetEl.style.width = "130px";
    targetEl.style.height = "28px";
    targetEl.style.zIndex = 9999;
    targetEl.style.right = "30vw";
    targetEl.style.top = "10px";
    // 隐藏
    targetEl.style.visibility = "hidden";
    document.body.appendChild(targetEl);
  }

  const rectFrom = sourceEl.getBoundingClientRect();
  const rectTo = targetEl.getBoundingClientRect();

  // 计算位移差值
  const diffX = rectTo.left - rectFrom.left;
  const diffY = rectTo.top - rectFrom.top;

  const gsap = await loadGSAP();

  // 创建金币诞生特效(只创建一次，固定位置)
  const birthEl = document.createElement("img");
  if (showBirth) {
    birthEl.src = coinBirth;
    birthEl.style.position = "fixed";
    birthEl.style.width = "260px";
    birthEl.style.height = "260px";
    // 放在按钮中心位置
    birthEl.style.left = `${rectFrom.left - 130}px`;
    birthEl.style.top = `${rectFrom.top - 130}px`;
    birthEl.style.pointerEvents = "none";
    birthEl.style.zIndex = 9998; // 低于金币
    birthEl.style.opacity = "0.9";
    document.body.appendChild(birthEl);
  }

  // 记录已完成的金币动画数量
  let completedAnimations = 0;

  // 创建一个函数创建单个金币并执行动画
  const createCoinWithEffect = (index) => {
    // 给每个金币设置稍微不同的起始位置
    const offsetX = Math.random() * 20 - 10; // -10px ~ 10px
    const offsetY = Math.random() * 10 - 5; // -5px ~ 5px
    const startX = rectFrom.left + offsetX + 20;
    const startY = rectFrom.top + offsetY;

    // 创建金币DOM
    const coinEl = document.createElement("img");
    // 随机 0-3
    const random = Math.floor(Math.random() * 4);
    coinEl.src = [coinImage1, coinImage2, coinImage3, coinImage4][random];
    coinEl.style.position = "fixed";
    coinEl.style.width = "40px";
    coinEl.style.pointerEvents = "none";
    coinEl.style.zIndex = 9999;
    coinEl.style.left = `${startX}px`;
    coinEl.style.top = `${startY}px`;
    document.body.appendChild(coinEl);

    // 为每个金币创建个性化的参数
    const duration = 0.8 + Math.random() * 0.4; // 0.8s ~ 1.2s
    const heightFactor = 3 + Math.random() * 2; // 3 ~ 5

    // 使用GSAP控制每个金币的动画
    gsap.to(coinEl, {
      duration: duration,
      ease: "power2.out",
      onUpdate: function () {
        // progress值在0-1之间
        const progress = this.progress();

        // 为每个金币设置不同的抛物线高度
        const parabolicY = -100 * progress * (1 - progress) * heightFactor;

        // 应用变换
        coinEl.style.transform = `translate(${diffX * progress}px, ${
          diffY * progress + parabolicY
        }px)`;
      },
      onComplete: function () {
        // 动画完成后移除元素
        coinEl.remove();

        // 增加完成计数
        completedAnimations++;

        // 当所有金币动画都完成时，移除特效元素
        if (completedAnimations === coinCount) {
          // 淡出特效
          if (!showBirth) {
            onComplete && onComplete();
          } else {
            gsap.to(birthEl, {
              duration: 0.2,
              opacity: 0,
              scale: 1.5,
              onComplete: function () {
                birthEl.remove();
                onComplete && onComplete();
                // that.showHeaderCoins = false;
                // that.close();
              },
            });
          }
        }
      },
    });
  };

  // 使用循环和setTimeout连续创建金币
  for (let i = 0; i < coinCount; i++) {
    setTimeout(() => {
      createCoinWithEffect(i);
    }, i * 100); // 每100ms创建一个金币
  }
  // that.showHeaderCoins = true;
  onInit && onInit();

  // 添加特效动画 - 轻微的缩放呼吸动画，直到所有金币结束
  if (showBirth) {
    gsap.to(birthEl, {
      duration: 1.2,
      scale: 1.1,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });
  }
}

/**
 * 获取汇率公共方法
 * @returns
 */
export function getCoinExchangeRateData() {
  return getCoinExchangeRate({
    toCoins: [Store.getters?.getUserCoins?.selectedCoinCode],
    appCoin: true,
  });
}

// 参数处理对象
export function queryToObj(queryStr) {
  if (typeof queryStr !== "string" || queryStr === "") {
    return {};
  }

  const obj = {};
  queryStr.split("&").forEach((part) => {
    const [key, value = ""] = part.split("=");
    obj[key] = decodeURIComponent(value); // 后面的会覆盖前面的
  });

  return obj;
}

export async function getAppPromptInfoFun() {
  const lang = vm.$store.getters.getLang || "en";
  let appConfigInfo = {};
  const ref = await getAppPromptInfo({});
  if (ref?.code === 0) {
    appConfigInfo = ref?.data || {};
  }
  const languagesArr = appConfigInfo.languages || [];
  const languagesObj = languagesArr.find((it) => it.language === lang) || {};
  vm.$eventPost("game_limit_popup");
  vm.$confirm(
    languagesObj.promptGameLimit,
    vm.$t("Datalang.Recharge_TIP_tip"),
    {
      confirmButtonText: languagesObj.promptGameLimitButton,
      showCancelButton: false,
      // showClose: false,
      closeOnClickModal: false,
      customClass: "game-tip-confirm",
      dangerouslyUseHTMLString: true,
    }
  )
    .then(async () => {
      vm.$eventPost("game_limit_popup_jump");
      goJoinEvent(appConfigInfo.promptGameLimitJump);
    })
    .catch(() => {
      vm.$eventPost("game_limit_popup_close");
    });
  return;
}

export function getTxtFun(walletTypeTxt) {
  const withdrawMode =
    vm.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
  if (walletTypeTxt === 1) {
    // 真实钱包
    if (withdrawMode === "WITHDRAW_MODE_NORMAL") {
      // 普通出款
      return vm.$t("Datalang.newly_This_is");
    }
    if (withdrawMode === "WITHDRAW_MODE_LIMIT") {
      // 限制出款
      return vm.$t("Datalang.newly_This_is7");
    }
    if (withdrawMode === "WITHDRAW_MODE_CLOSE") {
      // 不出款
      return vm.$t("Datalang.newly_This_is3");
    }

    if (withdrawMode === "WITHDRAW_MODE_FREE") {
      // 免打码
      return vm.$t("Datalang.newly_This_is1");
    }
    if (withdrawMode === "WITHDRAW_MODE_IGNORE") {
      // 不区分真实账户模式
      return vm.$t("Datalang.newly_This_is2");
    }
    if (withdrawMode === "WITHDRAW_MODE_FREE_GOLD") {
      // 免费金币现金打码模式
      return vm.$t("Datalang.newly_This_is2");
    }
  }
  if (walletTypeTxt === 2) {
    // 免费金币
    if (withdrawMode === "WITHDRAW_MODE_FREE") {
      // 免打码
      return vm.$t("Datalang.newly_Free_coins");
    } else if (withdrawMode === "WITHDRAW_MODE_FREE_GOLD") {
      // 免费金币现金打码模式
      return vm.$t("Datalang.newly_Free_bonus");
    } else {
      // 其他
      return vm.$t("Datalang.newly_Free3");
    }
  }
  if (walletTypeTxt === 3) {
    // 佣金钱包
    return vm.$t("Datalang.newly_The_promotional");
  }
}
export function goWithdrawFun(type) {
  const withdrawMode =
    vm.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
  if (type === 1) {
    vm.$Bus.$emit("showExchange", { show: true });
  }
  if (type === 2) {
    if (withdrawMode === "WITHDRAW_MODE_FREE_GOLD") {
      // 免费金币现金打码模式
      vm.$Bus.$emit("showFreeExchange", { show: true });
    } else if (withdrawMode === "WITHDRAW_MODE_FREE") {
      // 免打码
      vm.$Bus.$emit("showExchange", { show: true });
    } else {
      // 其他
      vm.$Bus.$emit("showCharge", { show: true });
    }
  }
  if (type === 3) {
    vm.$Bus.$emit("showExchange", {
      show: true,
      withdrawType: 2,
    });
  }
}
export function getBtnTxtFun() {
  const withdrawMode =
    vm.$store?.getters?.getPacketConfig?.appConfig?.withdrawMode;
  if (
    withdrawMode === "WITHDRAW_MODE_FREE" ||
    withdrawMode === "WITHDRAW_MODE_FREE_GOLD"
  ) {
    return vm.$t("Datalang.Menu_BTM_withdraw");
  } else {
    return vm.$t("Datalang.newly_unbind");
  }
}
export function goHandleChangeFun(coinCode) {
  // 佣金转余额
  vm.$confirm(
    vm.$t("Datalang.transfer_account"),
    vm.$t("Datalang.Recharge_TIP_tip"),
    {
      confirmButtonText: vm.$t("Datalang.Login_BTM_confirm"),
      cancelButtonText: vm.$t("Datalang.Recharge_BTM_cancle"),
      lockScroll: false,
    }
  )
    .then(async () => {
      const { code } = await transfer({
        // money: vm.checkedCoin.commissionWallet,
        coinCode: coinCode,
        transferType: 1,
      });
      if (code === 0) {
        vm.$message({
          message: vm.$t("Datalang.Event_TITLE_operationsuccessful"),
          type: "success",
          showClose: true,
        });
        vm.$store.dispatch("getUserInfo");
      }
    })
    .catch(() => {});
}

export function getDeviceType() {
  const ua = navigator.userAgent;
  const lowerUA = ua.toLowerCase();

  // Android
  const isAndroid = /android/.test(lowerUA);

  // iPhone / iPod
  const isIOS = /iphone|ipod/.test(lowerUA);

  // iPad + iPadOS13+（MacIntel + 多点触控）
  const isIPad =
    /ipad/.test(lowerUA) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isAndroid) return "DEVICE_TYPE_ANDROID";
  if (isIOS || isIPad) return "DEVICE_TYPE_IOS";

  // PC 设备（Win / Mac / Linux）
  const isPC = /win|mac|linux/i.test(navigator.platform);
  if (isPC) return "DEVICE_TYPE_WEB";

  // 兜底：智能电视、游戏机、未知设备
  return "DEVICE_TYPE_TV";
}

// 根据精度直接截取小数位，不进行四舍五入
export function truncateAccuracy(value, accuracy = 2) {
  if (value === null || value === undefined || isNaN(value)) {
    return "0";
  }

  const num = Number(value);
  // 除以 10^accuracy，和 divideAccuracy 保持一致
  const divisor = Math.pow(10, accuracy);
  const dividedValue = num / divisor;

  // 转换为字符串
  const str = String(dividedValue);

  // 如果没有小数点，补充小数点和0
  if (!str.includes(".")) {
    if (accuracy === 0) {
      return str;
    }
    return str + "." + "0".repeat(accuracy);
  }

  // 分割整数和小数部分
  const [integerPart, decimalPart] = str.split(".");

  // 直接截取指定精度的小数位
  if (accuracy === 0) {
    return integerPart;
  }

  // 截取或补齐小数位
  const truncatedDecimal = decimalPart
    .substring(0, accuracy)
    .padEnd(accuracy, "0");

  return `${integerPart}.${truncatedDecimal}`;
}

// usd 账号类型
export const cashTypeObj = {
  WITHDRAW_METHOD_PAYPAL: "PayPal",
  WITHDRAW_METHOD_USDT_VIRTUAL_COIN: "USDT",
  WITHDRAW_METHOD_CASHAPP: "CashApp",
};
